
// // assets/rejoes-builder.js - NO CHANGES NEEDED FOR THIS SPECIFIC REQUEST
// const RejoesBuilder = (() => {
//     const STORAGE_KEY_PREFIX = 'rejoes_mf_';

//     function saveSelection(key, value) {
//         sessionStorage.setItem(STORAGE_KEY_PREFIX + key, JSON.stringify(value));
//     }

//     function getSelection(key) {
//         const stored = sessionStorage.getItem(STORAGE_KEY_PREFIX + key);
//         try {
//             return stored ? JSON.parse(stored) : null;
//         } catch (e) {
//             console.error(`Error parsing sessionStorage key "${STORAGE_KEY_PREFIX + key}":`, e);
//             return null;
//         }
//     }

//     function clearPrefixedSelection(key) {
//         sessionStorage.removeItem(STORAGE_KEY_PREFIX + key);
//     }

//     function clearAllSelections() {
//         for (let i = 0; i < sessionStorage.length; i++) {
//             const key = sessionStorage.key(i);
//             if (key.startsWith(STORAGE_KEY_PREFIX)) {
//                 sessionStorage.removeItem(key);
//                 i--;
//             }
//         }
//         console.log("All Rejoes Mystery Fits selections cleared.");
//     }

//     function showStep(stepNumber) {
//         const targetSection = document.querySelector(`.mf-builder-step-section[data-step="${stepNumber}"]`);
//         if (targetSection) {
//             targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//             initStepLogic(stepNumber, targetSection);
//             window.history.pushState(null, '', `#step-${stepNumber}`);
//             console.log(`RejoesBuilder: Scrolled to step ${stepNumber} on the same page.`);

//             if (stepNumber === 5) {
//                 populateOrderSummary();
//             }
//         } else {
//             console.error(`RejoesBuilder: Step ${stepNumber} section not found. Falling back to Step 1.`);
//             window.history.pushState(null, '', `#step-1`);
//             showStep(1);
//         }
//     }

//     window.addEventListener('popstate', () => {
//         const hash = window.location.hash;
//         const stepNumber = hash ? parseInt(hash.replace('#step-', '')) : 1;
//         showStep(stepNumber);
//     });

//     async function handleAddToCart(variantId, properties, addToCartBtn) {
//         addToCartBtn.textContent = 'Adding...';
//         addToCartBtn.setAttribute('disabled', 'disabled');

//         const formData = new FormData();
//         formData.append('id', variantId);
//         formData.append('quantity', 1);

//         for (const key in properties) {
//             if (properties.hasOwnProperty(key) && properties[key] !== null && properties[key] !== 'null' && properties[key] !== '') {
//                 formData.append(`properties[${key}]`, properties[key]);
//             }
//         }

//         try {
//             const response = await fetch('/cart/add.js', {
//                 method: 'POST',
//                 body: formData
//             });

//             const data = await response.json();

//             if (data.status) {
//                 console.error('Add to cart error:', data.description);
//                 alert('Error adding item to cart: ' + data.description);
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//                 return false;
//             } else {
//                 console.log('Item added to cart:', data);
//                 clearAllSelections();
//                 window.location.href = '/cart';
//                 return true;
//             }
//         } catch (error) {
//             console.error('Network or unexpected error:', error);
//             alert('Could not add item to cart. Please try again.');
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//             return false;
//         }
//     }

//     function populateOrderSummary() {
//         const summarySection = document.querySelector('.mf-builder-step-section[data-step="5"]');
//         if (!summarySection) return;

//         const fitType = getSelection('fitType') || 'N/A';
//         const topSize = getSelection('top_size') || 'N/A';
//         const bottomSize = getSelection('bottom_size') || 'N/A';
//         const shoeSize = getSelection('shoe_size') || 'N/A';
//         const bagType = getSelection('bagType') || 'N/A';
//         const inspoFileName = getSelection('inspoFileName') || 'None';

//         const fitSizeDisplay = `${topSize}, ${bottomSize}, ${shoeSize}`;

//         const fitTypeElement = summarySection.querySelector('[data-summary-field="fit-type"]');
//         if (fitTypeElement) fitTypeElement.textContent = fitType;

//         const fitSizeElement = summarySection.querySelector('[data-summary-field="fit-size"]');
//         if (fitSizeElement) fitSizeElement.textContent = fitSizeDisplay;

//         const bagTypeElement = summarySection.querySelector('[data-summary-field="bag-type"]');
//         if (bagTypeElement) bagTypeElement.textContent = bagType;

//         const inspoImageElement = summarySection.querySelector('[data-summary-field="inspo-image"]');
//         if (inspoImageElement) {
//             const inspoImageUrl = getSelection('inspoImageUrl');
//             if (inspoImageUrl && inspoImageUrl !== 'null' && !inspoImageUrl.includes('placeholder.com')) {
//                 inspoImageElement.innerHTML = `<a href="${inspoImageUrl}" target="_blank" rel="noopener noreferrer">${inspoFileName}</a>`;
//             } else {
//                 inspoImageElement.textContent = inspoFileName;
//             }
//         }

//         console.log('Order summary populated with:', {
//             fitType,
//             fitSize: fitSizeDisplay,
//             bagType,
//             inspoFileName
//         });
//     }

//     function initStepLogic(stepNumber, sectionElement) {
//         const goBackButton = sectionElement.querySelector('#mf-go-back-btn');
//         if (goBackButton) {
//             const oldListenerRef = goBackButton.getAttribute('data-listener-ref');
//             if (oldListenerRef && window[oldListenerRef]) {
//                 goBackButton.removeEventListener('click', window[oldListenerRef]);
//                 delete window[oldListenerRef];
//             }

//             const newGoBackHandlerName = `goBackHandler${Date.now()}_${stepNumber}`;
//             window[newGoBackHandlerName] = () => {
//                 if (stepNumber > 1) {
//                     showStep(stepNumber - 1);
//                 } else {
//                     console.log("RejoesBuilder: Already on Step 1, cannot go back further.");
//                 }
//             };

//             goBackButton.addEventListener('click', window[newGoBackHandlerName]);
//             goBackButton.setAttribute('data-listener-ref', newGoBackHandlerName);
//         }

//         switch (stepNumber) {
//             case 1: initStep1(sectionElement); break;
//             case 2: initStep2(sectionElement); break;
//             case 3: initStep3(sectionElement); break;
//             case 4: initStep4(sectionElement); break;
//             case 5: initStep5(sectionElement); break;
//             default: console.warn(`RejoesBuilder: No specific initializer for step ${stepNumber}`);
//         }
//     }

//     function initStep1(sectionElement) {
//         const radioGroup = sectionElement.querySelector('.radio-group');
//         const choiceLabels = radioGroup ? radioGroup.querySelectorAll('input[type="radio"] + label') : [];
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedFitType = getSelection('fitType');

//         if (selectedFitType) {
//             choiceLabels.forEach(label => {
//                 if (label.dataset.value === selectedFitType) {
//                     label.previousElementSibling.checked = true;
//                     label.classList.add('active');
//                 } else {
//                     label.classList.remove('active');
//                 }
//             });
//             nextBtn.removeAttribute('disabled');
//         } else {
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         choiceLabels.forEach(label => {
//             const oldLabelClickListenerRef = label.getAttribute('data-listener-ref');
//             if (oldLabelClickListenerRef && window[oldLabelClickListenerRef]) {
//                 label.removeEventListener('click', window[oldLabelClickListenerRef]);
//                 delete window[oldLabelClickListenerRef];
//             }

//             const newLabelClickHandlerName = `labelClickHandler${Date.now()}_${label.dataset.value.replace(/\s+/g, '')}`;
//             window[newLabelClickHandlerName] = () => {
//                 choiceLabels.forEach(l => l.classList.remove('active'));
//                 label.classList.add('active');
//                 saveSelection('fitType', label.dataset.value);
//                 nextBtn.removeAttribute('disabled');
//             };

//             label.addEventListener('click', window[newLabelClickHandlerName]);
//             label.setAttribute('data-listener-ref', newLabelClickHandlerName);
//         });

//         const oldNextBtnClickListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnClickListenerRef && window[oldNextBtnClickListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnClickListenerRef]);
//             delete window[oldNextBtnClickListenerRef];
//         }

//         const newNextBtnClickHandlerName = `nextBtnClickHandler${Date.now()}_1`;
//         window[newNextBtnClickHandlerName] = () => {
//             if (getSelection('fitType')) {
//                 showStep(2);
//             } else {
//                 alert('Please select a gender fit to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnClickHandlerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnClickHandlerName);
//     }

//     function initStep2(sectionElement) {
//         const fileInput = sectionElement.querySelector('#mf-step2-inspo-upload');
//         const dropzoneContainer = sectionElement.querySelector(".mf-step2-dropzone-container");
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

//         const uploadPrompt = sectionElement.querySelector('#mf-step2-upload-prompt');
//         const uploadPreview = sectionElement.querySelector('#mf-step2-upload-preview');
//         const previewImage = sectionElement.querySelector('#mf-step2-preview-image');
//         const previewFilename = sectionElement.querySelector('#mf-step2-preview-filename');
//         const previewStatus = sectionElement.querySelector('#mf-step2-preview-status');
//         const removeFileBtn = sectionElement.querySelector('#mf-step2-remove-file-btn');

//         let storedFileName = getSelection('inspoFileName');
//         let storedImageUrl = getSelection('inspoImageUrl');

//         function updateFileStatusUI(fileName, imageUrl) {
//             if (fileName && imageUrl) {
//                 uploadPrompt.classList.add('hidden');
//                 uploadPreview.classList.remove('hidden');
//                 previewImage.src = imageUrl;
//                 previewFilename.textContent = fileName;
//                 previewStatus.textContent = 'File selected';
//                 nextBtn.removeAttribute('disabled');

//                 saveSelection('inspoFileName', fileName);
//                 saveSelection('inspoImageUrl', imageUrl);
//             } else {
//                 uploadPrompt.classList.remove('hidden');
//                 uploadPreview.classList.add('hidden');
//                 previewImage.src = '';
//                 previewFilename.textContent = '';
//                 previewStatus.textContent = 'No file selected';
//                 nextBtn.setAttribute('disabled', 'disabled');

//                 clearPrefixedSelection('inspoFileName');
//                 clearPrefixedSelection('inspoImageUrl');
//             }
//         }

//         updateFileStatusUI(storedFileName, storedImageUrl);

//         const oldFileInputListenerRef = fileInput.getAttribute('data-listener-ref');
//         if (oldFileInputListenerRef && window[oldFileInputListenerRef]) {
//             fileInput.removeEventListener('change', window[oldFileInputListenerRef]);
//             delete window[oldFileInputListenerRef];
//         }

//         const oldDropoverListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragover');
//         if (oldDropoverListenerRef && window[oldDropoverListenerRef]) {
//             dropzoneContainer.removeEventListener('dragover', window[oldDropoverListenerRef]);
//             delete window[oldDropoverListenerRef];
//         }

//         const oldDragleaveListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragleave');
//         if (oldDragleaveListenerRef && window[oldDragleaveListenerRef]) {
//             dropzoneContainer.removeEventListener('dragleave', window[oldDragleaveListenerRef]);
//             delete window[oldDragleaveListenerRef];
//         }

//         const oldDropListenerRef = dropzoneContainer.getAttribute('data-listener-ref-drop');
//         if (oldDropListenerRef && window[oldDropListenerRef]) {
//             dropzoneContainer.removeEventListener('drop', window[oldDropListenerRef]);
//             delete window[oldDropListenerRef];
//         }

//         const oldRemoveFileListenerRef = removeFileBtn.getAttribute('data-listener-ref');
//         if (oldRemoveFileListenerRef && window[oldRemoveFileListenerRef]) {
//             removeFileBtn.removeEventListener('click', window[oldRemoveFileListenerRef]);
//             delete window[oldRemoveFileListenerRef];
//         }

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const handleFileRemove = () => {
//             fileInput.value = '';
//             updateFileStatusUI(null, null);
//         };

//         const newFileInputListenerName = `fileInputHandler${Date.now()}`;
//         window[newFileInputListenerName] = function(event) {
//             const file = event.target.files[0];
//             if (!file) {
//                 handleFileRemove();
//                 return;
//             }

//             const maxSize = 5 * 1024 * 1024;
//             if (file.size > maxSize) {
//                 alert('File is too large. Maximum size is 5MB.');
//                 handleFileRemove();
//                 return;
//             }

//             const localPreviewUrl = URL.createObjectURL(file);
//             updateFileStatusUI(file.name, localPreviewUrl);
//             console.log("RejoesBuilder: File selected for Uploadery:", file.name); // Changed console log message
//         };

//         fileInput.addEventListener("change", window[newFileInputListenerName]);
//         fileInput.setAttribute('data-listener-ref', newFileInputListenerName);
//         const newDragoverListenerName = `dragoverHandler${Date.now()}`;
//         window[newDragoverListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.add("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragover", window[newDragoverListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragover', newDragoverListenerName);
//         const newDragleaveListenerName = `dragleaveHandler${Date.now()}`;
//         window[newDragleaveListenerName] = function(event) {
//             dropzoneContainer.classList.remove("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragleave", window[newDragleaveListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragleave', newDragleaveListenerName);
//         const newDropListenerName = `dropHandler${Date.now()}`;
//         window[newDropListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.remove("drag-over");
//             const files = event.dataTransfer.files;
//             if (files.length > 0) {
//                 const dataTransfer = new DataTransfer();
//                 dataTransfer.items.add(files[0]);
//                 fileInput.files = dataTransfer.files;
//                 fileInput.dispatchEvent(new Event('change'));
//             }
//         };

//         dropzoneContainer.addEventListener("drop", window[newDropListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-drop', newDropListenerName);

//         const newRemoveFileListenerName = `removeFileHandler${Date.now()}`;
//         window[newRemoveFileListenerName] = handleFileRemove;

//         removeFileBtn.addEventListener('click', window[newRemoveFileListenerName]);
//         removeFileBtn.setAttribute('data-listener-ref', newRemoveFileListenerName);
//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_2`;
//         window[newNextBtnListenerName] = function() {
//             if (getSelection('inspoFileName') && getSelection('inspoImageUrl')) {
//                 showStep(3);
//             } else {
//                 alert('Please upload an inspiration image to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep3(sectionElement) {
//         const sizeSelectors = sectionElement.querySelectorAll(".mf-step3-size-selector select");
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         const sizeSelectorGroup = sectionElement.querySelector('.mf-step3-size-selector-group');

//         const variantsRaw = sectionElement.dataset.variants;
//         const optionsRaw = sectionElement.dataset.options;

//         let currentProductVariants = JSON.parse(variantsRaw || '[]');
//         let currentProductOptions = JSON.parse(optionsRaw || '[]');
//         const selectedProductId = sizeSelectorGroup ? sizeSelectorGroup.dataset.productId : null;

//         sizeSelectors.forEach(selectElement => {
//             const optionId = selectElement.id.replace('mf-step3-size-', '');
//             const storageKey = optionId;
//             let savedValue = getSelection(storageKey);

//             if (savedValue) {
//                 selectElement.value = savedValue;
//             }

//             const oldChangeListenerRef = selectElement.getAttribute('data-listener-ref');
//             if (oldChangeListenerRef && window[oldChangeListenerRef]) {
//                 selectElement.removeEventListener('change', window[oldChangeListenerRef]);
//                 delete window[oldChangeListenerRef];
//             }

//             const newChangeListenerName = `selectChangeListener${Date.now()}_${optionId}`;
//             window[newChangeListenerName] = function() {
//                 saveSelection(storageKey, this.value);
//                 console.log(`RejoesBuilder: Saved ${storageKey}:`, this.value);
//                 updateNextButtonState();
//             };

//             selectElement.addEventListener("change", window[newChangeListenerName]);
//             selectElement.setAttribute('data-listener-ref', newChangeListenerName);
//         });

//         function updateNextButtonState() {
//             const allSelected = Array.from(sizeSelectors).every(select => select.value !== '');
//             let variantMatched = false;
//             let matchedVariantId = null;

//             if (selectedProductId && currentProductVariants.length > 0 && currentProductOptions.length > 0) {
//                 const selectedOptions = Array.from(sizeSelectors).map(select => select.value);

//                 const matchedVariant = currentProductVariants.find(variant => {
//                     const isMatch = currentProductOptions.every((optionName, index) => {
//                         const optionKey = `option${index + 1}`;
//                         return variant[optionKey] === selectedOptions[index];
//                     });
//                     return isMatch;
//                 });

//                 variantMatched = !!matchedVariant;

//                 if (matchedVariant) {
//                     matchedVariantId = matchedVariant.id;
//                     saveSelection('selectedSizeVariantId', matchedVariant.id);
//                 } else {
//                     clearPrefixedSelection('selectedSizeVariantId');
//                 }
//             } else {
//                 variantMatched = allSelected;
//                 clearPrefixedSelection('selectedSizeVariantId');
//             }

//             if (allSelected && variantMatched) {
//                 nextBtn.removeAttribute('disabled');
//             } else {
//                 nextBtn.setAttribute('disabled', 'disabled');
//             }
//         }

//         updateNextButtonState();

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_3`;
//         window[newNextBtnListenerName] = function() {
//             const selectedVariantId = getSelection('selectedSizeVariantId');
//             if (selectedVariantId) {
//                 console.log("RejoesBuilder: Next button clicked in Step 3. Proceeding to Step 4.");

//                 saveSelection('selectedCartVariantId', selectedVariantId);

//                 showStep(4);
//             } else {
//                 alert('Please select all sizes and ensure a valid product variant is selected to proceed.');
//                 console.warn("RejoesBuilder: Attempted to proceed from Step 3 without a selected variant.");
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep4(sectionElement) {
//         const bagTypeOptions = sectionElement.querySelectorAll('.mf-step4-bag-type-option');
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedBagType = getSelection('bagType');

//         if (selectedBagType) {
//             bagTypeOptions.forEach(option => {
//                 const variantTitle = option.dataset.variantTitle;

//                 if (variantTitle === selectedBagType) {
//                     option.classList.add('active');
//                     const radioInput = option.querySelector('input[type="radio"]');
//                     if (radioInput) radioInput.checked = true;
//                 } else {
//                     option.classList.remove('active');
//                 }
//             });
//             nextBtn.removeAttribute('disabled');
//         } else {
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         bagTypeOptions.forEach(option => {
//             const oldClickListenerRef = option.getAttribute('data-listener-ref');
//             if (oldClickListenerRef && window[oldClickListenerRef]) {
//                 option.removeEventListener('click', window[oldClickListenerRef]);
//                 delete window[oldClickListenerRef];
//             }

//             const newClickListenerName = `optionClickHandler${Date.now()}_${option.dataset.variantTitle.replace(/\s+/g, '')}`;
//             window[newClickListenerName] = function() {
//                 bagTypeOptions.forEach(opt => {
//                     opt.classList.remove('active');
//                     const radioInput = opt.querySelector('input[type="radio"]');
//                     if (radioInput) radioInput.checked = false;
//                 });

//                 option.classList.add('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = true;

//                 const variantTitle = option.dataset.variantTitle;

//                 saveSelection('bagType', variantTitle);
//                 clearPrefixedSelection('selectedBagOptionVariantId');

//                 nextBtn.removeAttribute('disabled');
//             };

//             option.addEventListener('click', window[newClickListenerName]);
//             option.setAttribute('data-listener-ref', newClickListenerName);
//         });

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_4`;
//         window[newNextBtnListenerName] = function() {
//             if (getSelection('bagType')) {
//                 showStep(5);
//             } else {
//                 alert('Please select a bag type to continue.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep5(sectionElement) {
//         const addToCartBtn = sectionElement.querySelector('#mf-add-to-cart-btn');
//         const oldAddToCartListenerRef = addToCartBtn.getAttribute('data-listener-ref');

//         if (oldAddToCartListenerRef && window[oldAddToCartListenerRef]) {
//             addToCartBtn.removeEventListener('click', window[oldAddToCartListenerRef]);
//             delete window[oldAddToCartListenerRef];
//         }

//         const newAddToCartListenerName = `addToCartHandler${Date.now()}`;
//         window[newAddToCartListenerName] = async (e) => {
//             e.preventDefault();
//             addToCartBtn.textContent = 'Adding...';
//             addToCartBtn.setAttribute('disabled', 'disabled');

//             const baseProductVariantId = getSelection('selectedCartVariantId');

//             if (!baseProductVariantId) {
//                 alert('Cannot add to cart: Base product variant not selected or found (from Step 3).');
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//                 return;
//             }

//             const properties = {
//                 "Fit Type": getSelection('fitType'),
//                 "Top Size": getSelection('top_size'),
//                 "Bottom Size": getSelection('bottom_size'),
//                 "Shoe Size": getSelection('shoe_size'),
//                 "Bag Type": getSelection('bagType'),
//                 "Inspo Image URL": getSelection('inspoImageUrl') || (getSelection('inspoFileName') ? `File: ${getSelection('inspoFileName')}` : 'N/A')
//             };

//             const success = await handleAddToCart(baseProductVariantId, properties, addToCartBtn);

//             if (!success) {
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//             }
//         };

//         addToCartBtn.addEventListener('click', window[newAddToCartListenerName]);
//         addToCartBtn.setAttribute('data-listener-ref', newAddToCartListenerName);
//     }

//     function initBuilder() {
//         const allStepSections = document.querySelectorAll('.mf-builder-step-section');

//         if (allStepSections.length === 0) {
//             console.warn('RejoesBuilder: No .mf-builder-step-section found. Ensure your sections have this class.');
//             return;
//         }

//         const initialHash = window.location.hash;
//         const initialStep = initialHash ? parseInt(initialHash.replace('#step-', '')) : 1;
//         showStep(initialStep);
//     }

//     return {
//         init: initBuilder,
//         showStep: showStep,
//         saveSelection: saveSelection,
//         getSelection: getSelection,
//         clearAllSelections: clearAllSelections
//     };
// })();


// // latest final code 
// const RejoesBuilder = (() => {
//     const STORAGE_KEY_PREFIX = 'rejoes_mf_';
//     let _selectedInspoFile = null;

//     function checkAndClearSelectionsIfNeeded() {
//         const hasJustCompleted = sessionStorage.getItem('rejoes_mf_just_completed');
        
//         if (hasJustCompleted || !window.location.href.includes('#')) {
//             clearAllSelections();
//             sessionStorage.removeItem('rejoes_mf_just_completed');
//             return true;
//         }
//         return false;
//     }

//     function saveSelection(key, value) {
//         sessionStorage.setItem(STORAGE_KEY_PREFIX + key, JSON.stringify(value));
//     }

//     function getSelection(key) {
//         const stored = sessionStorage.getItem(STORAGE_KEY_PREFIX + key);
//         try {
//             return stored ? JSON.parse(stored) : null;
//         } catch (e) {
//             console.error(`Error parsing sessionStorage key "${STORAGE_KEY_PREFIX + key}":`, e);
//             return null;
//         }
//     }

//     function clearPrefixedSelection(key) {
//         sessionStorage.removeItem(STORAGE_KEY_PREFIX + key);
//     }

//     function clearAllSelections() {
//         for (let i = 0; i < sessionStorage.length; i++) {
//             const key = sessionStorage.key(i);
//             if (key.startsWith(STORAGE_KEY_PREFIX)) {
//                 sessionStorage.removeItem(key);
//                 i--;
//             }
//         }
//         _selectedInspoFile = null;
//         console.log("All Rejoes Mystery Fits selections cleared.");
//     }

//     function showStep(stepNumber) {
//         const targetSection = document.querySelector(`.mf-builder-step-section[data-step="${stepNumber}"]`);
//         if (targetSection) {
//             document.querySelectorAll('.mf-builder-step-section').forEach(section => {
//                 section.style.display = 'none';
//             });
            
//             targetSection.style.display = 'block';
            
//             initStepLogic(stepNumber, targetSection);
//             window.history.pushState(null, '', `#step-${stepNumber}`);
//             console.log(`RejoesBuilder: Showing step ${stepNumber}.`);

//             setTimeout(() => {
//                 targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//             }, 100);

//             if (stepNumber === 5) {
//                 populateOrderSummary();
//             }
//         } else {
//             console.error(`RejoesBuilder: Step ${stepNumber} section not found. Falling back to Step 1.`);
//             window.history.pushState(null, '', `#step-1`);
//             showStep(1);
//         }
//     }

//     window.addEventListener('popstate', () => {
//         const hash = window.location.hash;
//         const stepNumber = hash ? parseInt(hash.replace('#step-', '')) : 1;
//         showStep(stepNumber);
//     });

//     async function handleAddToCart(variantId, properties, addToCartBtn) {
//         addToCartBtn.textContent = 'Adding...';
//         addToCartBtn.setAttribute('disabled', 'disabled');

//         const formData = new FormData();
//         formData.append('id', variantId);
//         formData.append('quantity', 1);

//         for (const key in properties) {
//             if (properties.hasOwnProperty(key) && properties[key] !== null && properties[key] !== 'null' && properties[key] !== '') {
//                 if (key !== "Inspo Image URL") {
//                     formData.append(`properties[${key}]`, properties[key]);
//                 }
//             }
//         }

//         if (_selectedInspoFile) {
//             formData.append('properties[Inspo Image]', _selectedInspoFile, _selectedInspoFile.name);
//         } else {
//             formData.append('properties[Inspo Image]', 'No image uploaded');
//         }

//         try {
//             const response = await fetch('/cart/add.js', {
//                 method: 'POST',
//                 body: formData
//             });

//             const data = await response.json();

//             if (data.status) {
//                 console.error('Add to cart error:', data.description);
//                 alert('Error adding item to cart: ' + data.description);
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//                 return false;
//             } else {
//                 console.log('Item added to cart:', data);
//                 sessionStorage.setItem('rejoes_mf_just_completed', 'true');
//                 clearAllSelections();
//                 window.location.href = '/cart';
//                 return true;
//             }
//         } catch (error) {
//             console.error('Network or unexpected error:', error);
//             alert('Could not add item to cart. Please try again.');
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//             return false;
//         }
//     }

//     // function populateOrderSummary() {
//     //     const summarySection = document.querySelector('.mf-builder-step-section[data-step="5"]');
//     //     if (!summarySection) return;

//     //     const fitType = getSelection('fitType') || 'N/A';
//     //     const topSize = getSelection('top_size') || 'N/A';
//     //     const bottomSize = getSelection('bottom_size') || 'N/A';
//     //     const shoeSize = getSelection('shoe_size') || 'N/A';
//     //     const bagType = getSelection('bagType') || 'N/A';
//     //     const inspoFileName = getSelection('inspoFileName') || 'None';

//     //     const fitSizeDisplay = `${topSize}, ${bottomSize}, ${shoeSize}`;

//     //     const fitTypeElement = summarySection.querySelector('[data-summary-field="fit-type"]');
//     //     if (fitTypeElement) fitTypeElement.textContent = fitType;

//     //     const fitSizeElement = summarySection.querySelector('[data-summary-field="fit-size"]');
//     //     if (fitSizeElement) fitSizeElement.textContent = fitSizeDisplay;

//     //     const bagTypeElement = summarySection.querySelector('[data-summary-field="bag-type"]');
//     //     if (bagTypeElement) bagTypeElement.textContent = bagType;

//     //     const inspoImageElement = summarySection.querySelector('[data-summary-field="inspo-image"]');
//     //     if (inspoImageElement) {
//     //         if (_selectedInspoFile) {
//     //             const inspoImageUrl = URL.createObjectURL(_selectedInspoFile);
//     //             inspoImageElement.innerHTML = `<a href="${inspoImageUrl}" target="_blank" rel="noopener noreferrer">${_selectedInspoFile.name}</a>`;
//     //         } else if (getSelection('inspoImageUrl') && getSelection('inspoFileName') !== 'None') {
//     //             const storedImageUrl = getSelection('inspoImageUrl');
//     //             const storedFileName = getSelection('inspoFileName');
//     //             const displayFileName = storedImageUrl.startsWith('blob:') ? `${storedFileName} (re-upload recommended)` : storedFileName;
//     //             inspoImageElement.innerHTML = `<a href="${storedImageUrl}" target="_blank" rel="noopener noreferrer">${displayFileName}</a>`;
//     //         } else {
//     //             inspoImageElement.textContent = inspoFileName;
//     //         }
//     //     }

//     //     console.log('RejoesBuilder: Order summary populated with:', {
//     //         fitType,
//     //         fitSize: fitSizeDisplay,
//     //         bagType,
//     //         inspoFileName
//     //     });
//     // }

//         function populateOrderSummary() {
//         const summarySection = document.querySelector('.mf-builder-step-section[data-step="5"]');
//         if (!summarySection) return;

//         const fitType = getSelection('fitType') || 'N/A';

//         // Retrieve all specific size selections using the correct keys
//         const topSize = getSelection('top_size') || 'N/A';
//         const jeansWaist = getSelection('jeans_waist') || 'N/A';
//         const jeansLength = getSelection('jeans_length') || 'N/A';
//         const sportBottoms = getSelection('sport_bottoms') || 'N/A';
//         const shoesSize = getSelection('shoes_size') || 'N/A'; // Corrected key

//         const bagType = getSelection('bagType') || 'N/A';
//         const inspoFileName = getSelection('inspoFileName') || 'None';

//         // Construct the display string to include all relevant sizes
//         // Filter out 'N/A' values if you prefer a cleaner display
//         const selectedSizes = [];
//         if (topSize !== 'N/A') selectedSizes.push(`Top: ${topSize}`);
//         if (jeansWaist !== 'N/A' || jeansLength !== 'N/A') selectedSizes.push(`Jeans: ${jeansWaist}/${jeansLength}`);
//         if (sportBottoms !== 'N/A') selectedSizes.push(`Sport Bottoms: ${sportBottoms}`);
//         if (shoesSize !== 'N/A') selectedSizes.push(`Shoes: EU ${shoesSize}`);

//         const fitSizeDisplay = selectedSizes.length > 0 ? selectedSizes.join(', ') : 'N/A';

//         const fitTypeElement = summarySection.querySelector('[data-summary-field="fit-type"]');
//         if (fitTypeElement) fitTypeElement.textContent = fitType;

//         const fitSizeElement = summarySection.querySelector('[data-summary-field="fit-size"]');
//         if (fitSizeElement) fitSizeElement.textContent = fitSizeDisplay;

//         const bagTypeElement = summarySection.querySelector('[data-summary-field="bag-type"]');
//         if (bagTypeElement) bagTypeElement.textContent = bagType;

//         const inspoImageElement = summarySection.querySelector('[data-summary-field="inspo-image"]');
//         if (inspoImageElement) {
//             if (_selectedInspoFile) {
//                 const inspoImageUrl = URL.createObjectURL(_selectedInspoFile);
//                 inspoImageElement.innerHTML = `<a href="${inspoImageUrl}" target="_blank" rel="noopener noreferrer">${_selectedInspoFile.name}</a>`;
//             } else if (getSelection('inspoImageUrl') && getSelection('inspoFileName') !== 'None') {
//                 const storedImageUrl = getSelection('inspoImageUrl');
//                 const storedFileName = getSelection('inspoFileName');
//                 const displayFileName = storedImageUrl.startsWith('blob:') ? `${storedFileName} (re-upload recommended)` : storedFileName;
//                 inspoImageElement.innerHTML = `<a href="${storedImageUrl}" target="_blank" rel="noopener noreferrer">${displayFileName}</a>`;
//             } else {
//                 inspoImageElement.textContent = inspoFileName;
//             }
//         }

//         console.log('RejoesBuilder: Order summary populated with:', {
//             fitType,
//             fitSize: fitSizeDisplay,
//             bagType,
//             inspoFileName
//         });
//     }

//     function initStepLogic(stepNumber, sectionElement) {
//         const goBackButton = sectionElement.querySelector('#mf-go-back-btn');
//         if (goBackButton) {
//             const oldListenerRef = goBackButton.getAttribute('data-listener-ref');
//             if (oldListenerRef && window[oldListenerRef]) {
//                 goBackButton.removeEventListener('click', window[oldListenerRef]);
//                 delete window[oldListenerRef];
//             }

//             const newGoBackHandlerName = `goBackHandler${Date.now()}_${stepNumber}`;
//             window[newGoBackHandlerName] = () => {
//                 if (stepNumber > 1) {
//                     showStep(stepNumber - 1);
//                 } else {
//                     console.log("RejoesBuilder: Already on Step 1, cannot go back further.");
//                 }
//             };

//             goBackButton.addEventListener('click', window[newGoBackHandlerName]);
//             goBackButton.setAttribute('data-listener-ref', newGoBackHandlerName);
//         }

//         switch (stepNumber) {
//             case 1: initStep1(sectionElement); break;
//             case 2: initStep2(sectionElement); break;
//             case 3: initStep3(sectionElement); break;
//             case 4: initStep4(sectionElement); break;
//             case 5: initStep5(sectionElement); break;
//             default: console.warn(`RejoesBuilder: No specific initializer for step ${stepNumber}`);
//         }
//     }

//     function initStep1(sectionElement) {
//         const radioGroup = sectionElement.querySelector('.radio-group');
//         const choiceLabels = radioGroup ? radioGroup.querySelectorAll('input[type="radio"] + label') : [];
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedFitType = getSelection('fitType');

//         if (selectedFitType) {
//             choiceLabels.forEach(label => {
//                 if (label.dataset.value === selectedFitType) {
//                     label.previousElementSibling.checked = true;
//                     label.classList.add('active');
//                 } else {
//                     label.classList.remove('active');
//                 }
//             });
//             nextBtn.removeAttribute('disabled');
//         } else {
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         choiceLabels.forEach(label => {
//             const oldLabelClickListenerRef = label.getAttribute('data-listener-ref');
//             if (oldLabelClickListenerRef && window[oldLabelClickListenerRef]) {
//                 label.removeEventListener('click', window[oldLabelClickListenerRef]);
//                 delete window[oldLabelClickListenerRef];
//             }

//             const newLabelClickHandlerName = `labelClickHandler${Date.now()}_${label.dataset.value.replace(/\s+/g, '')}`;
//             window[newLabelClickHandlerName] = () => {
//                 choiceLabels.forEach(l => l.classList.remove('active'));
//                 label.classList.add('active');
//                 saveSelection('fitType', label.dataset.value);
//                 nextBtn.removeAttribute('disabled');
//             };

//             label.addEventListener('click', window[newLabelClickHandlerName]);
//             label.setAttribute('data-listener-ref', newLabelClickHandlerName);
//         });

//         const oldNextBtnClickListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnClickListenerRef && window[oldNextBtnClickListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnClickListenerRef]);
//             delete window[oldNextBtnClickListenerRef];
//         }

//         const newNextBtnClickHandlerName = `nextBtnClickHandler${Date.now()}_1`;
//         window[newNextBtnClickHandlerName] = () => {
//             if (getSelection('fitType')) {
//                 showStep(2);
//             } else {
//                 alert('Please select a gender fit to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnClickHandlerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnClickHandlerName);
//     }

//     function initStep2(sectionElement) {
//         const fileInput = sectionElement.querySelector('#mf-step2-inspo-upload');
//         const dropzoneContainer = sectionElement.querySelector(".mf-step2-dropzone-container");
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

//         const uploadPrompt = sectionElement.querySelector('#mf-step2-upload-prompt');
//         const uploadPreview = sectionElement.querySelector('#mf-step2-upload-preview');
//         const previewImage = sectionElement.querySelector('#mf-step2-preview-image');
//         const previewFilename = sectionElement.querySelector('#mf-step2-preview-filename');
//         const previewStatus = sectionElement.querySelector('#mf-step2-preview-status');
//         const removeFileBtn = sectionElement.querySelector('#mf-step2-remove-file-btn');

//         function updateFileState(file) {
//             _selectedInspoFile = file;

//             if (file) {
//                 const localPreviewUrl = URL.createObjectURL(file);
//                 uploadPrompt.classList.add('hidden');
//                 uploadPreview.classList.remove('hidden');
//                 previewImage.src = localPreviewUrl;
//                 previewFilename.textContent = file.name;
//                 previewStatus.textContent = 'File selected';
//                 nextBtn.removeAttribute('disabled');

//                 saveSelection('inspoFileName', file.name);
//                 saveSelection('inspoImageUrl', localPreviewUrl);
//             } else {
//                 uploadPrompt.classList.remove('hidden');
//                 uploadPreview.classList.add('hidden');
//                 previewImage.src = '';
//                 previewFilename.textContent = '';
//                 previewStatus.textContent = 'No file selected';
//                 nextBtn.setAttribute('disabled', 'disabled');
                
//                 clearPrefixedSelection('inspoFileName');
//                 clearPrefixedSelection('inspoImageUrl');
//                 if (fileInput) fileInput.value = '';
//             }
//         }

//         if (_selectedInspoFile) {
//             updateFileState(_selectedInspoFile);
//         } else if (getSelection('inspoFileName')) {
//             uploadPrompt.classList.add('hidden');
//             uploadPreview.classList.remove('hidden');
//             previewImage.src = getSelection('inspoImageUrl') || 'https://via.placeholder.com/150?text=No+Preview';
//             previewFilename.textContent = getSelection('inspoFileName');
//             previewStatus.textContent = 'File previously selected (re-upload to include in order)';
//             nextBtn.setAttribute('disabled', 'disabled');
//         } else {
//             updateFileState(null);
//         }

//         const oldFileInputListenerRef = fileInput.getAttribute('data-listener-ref');
//         if (oldFileInputListenerRef && window[oldFileInputListenerRef]) {
//             fileInput.removeEventListener('change', window[oldFileInputListenerRef]);
//             delete window[oldFileInputListenerRef];
//         }

//         const oldDropoverListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragover');
//         if (oldDropoverListenerRef && window[oldDropoverListenerRef]) {
//             dropzoneContainer.removeEventListener('dragover', window[oldDropoverListenerRef]);
//             delete window[oldDropoverListenerRef];
//         }

//         const oldDragleaveListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragleave');
//         if (oldDragleaveListenerRef && window[oldDragleaveListenerRef]) {
//             dropzoneContainer.removeEventListener('dragleave', window[oldDragleaveListenerRef]);
//             delete window[oldDragleaveListenerRef];
//         }

//         const oldDropListenerRef = dropzoneContainer.getAttribute('data-listener-ref-drop');
//         if (oldDropListenerRef && window[oldDropListenerRef]) {
//             dropzoneContainer.removeEventListener('drop', window[oldDropListenerRef]);
//             delete window[oldDropListenerRef];
//         }

//         const oldRemoveFileListenerRef = removeFileBtn.getAttribute('data-listener-ref');
//         if (oldRemoveFileListenerRef && window[oldRemoveFileListenerRef]) {
//             removeFileBtn.removeEventListener('click', window[oldRemoveFileListenerRef]);
//             delete window[oldRemoveFileListenerRef];
//         }

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const handleFileRemove = () => {
//             fileInput.value = '';
//             updateFileState(null);
//         };

//         const newFileInputListenerName = `fileInputHandler${Date.now()}`;
//         window[newFileInputListenerName] = function(event) {
//             const file = event.target.files[0];
//             if (!file) {
//                 handleFileRemove();
//                 return;
//             }

//             const maxSize = 5 * 1024 * 1024;
//             if (file.size > maxSize) {
//                 alert('File is too large. Maximum size is 5MB.');
//                 handleFileRemove();
//                 return;
//             }

//             updateFileState(file);
//             console.log("RejoesBuilder: File selected for Uploadery:", file.name);
//         };

//         fileInput.addEventListener("change", window[newFileInputListenerName]);
//         fileInput.setAttribute('data-listener-ref', newFileInputListenerName);

//         const newDragoverListenerName = `dragoverHandler${Date.now()}`;
//         window[newDragoverListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.add("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragover", window[newDragoverListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragover', newDragoverListenerName);

//         const newDragleaveListenerName = `dragleaveHandler${Date.now()}`;
//         window[newDragleaveListenerName] = function(event) {
//             dropzoneContainer.classList.remove("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragleave", window[newDragleaveListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragleave', newDragleaveListenerName);

//         const newDropListenerName = `dropHandler${Date.now()}`;
//         window[newDropListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.remove("drag-over");
//             const files = event.dataTransfer.files;
//             if (files.length > 0) {
//                 const dataTransfer = new DataTransfer();
//                 dataTransfer.items.add(files[0]);
//                 fileInput.files = dataTransfer.files;
//                 fileInput.dispatchEvent(new Event('change'));
//             }
//         };

//         dropzoneContainer.addEventListener("drop", window[newDropListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-drop', newDropListenerName);

//         const newRemoveFileListenerName = `removeFileHandler${Date.now()}`;
//         window[newRemoveFileListenerName] = handleFileRemove;

//         removeFileBtn.addEventListener('click', window[newRemoveFileListenerName]);
//         removeFileBtn.setAttribute('data-listener-ref', newRemoveFileListenerName);

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_2`;
//         window[newNextBtnListenerName] = function() {
//             if (_selectedInspoFile) {
//                 showStep(3);
//             } else {
//                 alert('Please upload an inspiration image to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     // function initStep3(sectionElement) {
//     //     const sizeSelectors = sectionElement.querySelectorAll(".mf-step3-size-selector select");
//     //     const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//     //     const sizeSelectorGroup = sectionElement.querySelector('.mf-step3-size-selector-group');

//     //     const variantsRaw = sectionElement.dataset.variants;
//     //     const optionsRaw = sectionElement.dataset.options;

//     //     let currentProductVariants = JSON.parse(variantsRaw || '[]');
//     //     let currentProductOptions = JSON.parse(optionsRaw || '[]');
//     //     const selectedProductId = sizeSelectorGroup ? sizeSelectorGroup.dataset.productId : null;

//     //     sizeSelectors.forEach(selectElement => {
//     //         const optionId = selectElement.id.replace('mf-step3-size-', '');
//     //         const storageKey = optionId;
//     //         let savedValue = getSelection(storageKey);

//     //         if (savedValue) {
//     //             selectElement.value = savedValue;
//     //         }

//     //         const oldChangeListenerRef = selectElement.getAttribute('data-listener-ref');
//     //         if (oldChangeListenerRef && window[oldChangeListenerRef]) {
//     //             selectElement.removeEventListener('change', window[oldChangeListenerRef]);
//     //             delete window[oldChangeListenerRef];
//     //         }

//     //         const newChangeListenerName = `selectChangeListener${Date.now()}_${optionId}`;
//     //         window[newChangeListenerName] = function() {
//     //             saveSelection(storageKey, this.value);
//     //             console.log(`RejoesBuilder: Saved ${storageKey}:`, this.value);
//     //             updateNextButtonState();
//     //         };

//     //         selectElement.addEventListener("change", window[newChangeListenerName]);
//     //         selectElement.setAttribute('data-listener-ref', newChangeListenerName);
//     //     });

//     //     function updateNextButtonState() {
//     //         const allSelected = Array.from(sizeSelectors).every(select => select.value !== '');
//     //         let variantMatched = false;
//     //         let matchedVariantId = null;

//     //         if (selectedProductId && currentProductVariants.length > 0 && currentProductOptions.length > 0) {
//     //             const selectedOptions = Array.from(sizeSelectors).map(select => select.value);

//     //             const matchedVariant = currentProductVariants.find(variant => {
//     //                 const isMatch = currentProductOptions.every((optionName, index) => {
//     //                     const optionKey = `option${index + 1}`;
//     //                     return variant[optionKey] === selectedOptions[index];
//     //                 });
//     //                 return isMatch;
//     //             });

//     //             variantMatched = !!matchedVariant;

//     //             if (matchedVariant) {
//     //                 matchedVariantId = matchedVariant.id;
//     //                 saveSelection('selectedSizeVariantId', matchedVariant.id);
//     //             } else {
//     //                 clearPrefixedSelection('selectedSizeVariantId');
//     //             }
//     //         } else {
//     //             variantMatched = allSelected;
//     //             clearPrefixedSelection('selectedSizeVariantId');
//     //         }

//     //         if (allSelected && variantMatched) {
//     //             nextBtn.removeAttribute('disabled');
//     //         } else {
//     //             nextBtn.setAttribute('disabled', 'disabled');
//     //         }
//     //     }

//     //     updateNextButtonState();

//     //     const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//     //     if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//     //         nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//     //         delete window[oldNextBtnListenerRef];
//     //     }

//     //     const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_3`;
//     //     window[newNextBtnListenerName] = function() {
//     //         const selectedVariantId = getSelection('selectedSizeVariantId');
//     //         if (selectedVariantId) {
//     //             console.log("RejoesBuilder: Next button clicked in Step 3. Proceeding to Step 4.");

//     //             saveSelection('selectedCartVariantId', selectedVariantId);

//     //             showStep(4);
//     //         } else {
//     //             alert('Please select all sizes and ensure a valid product variant is selected to proceed.');
//     //             console.warn("RejoesBuilder: Attempted to proceed from Step 3 without a selected variant.");
//     //         }
//     //     };

//     //     nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//     //     nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     // }

// function initStep3(sectionElement) {
//     const sizeSelectors = sectionElement.querySelectorAll(".mf-step3-size-selector select");
//     const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

//     sizeSelectors.forEach(selectElement => {
//         const optionName = selectElement.name;
//         let savedValue = getSelection(optionName);

//         if (savedValue) {
//             selectElement.value = savedValue;
//         }

//         const oldChangeListenerRef = selectElement.getAttribute('data-listener-ref');
//         if (oldChangeListenerRef && window[oldChangeListenerRef]) {
//             selectElement.removeEventListener('change', window[oldChangeListenerRef]);
//             delete window[oldChangeListenerRef];
//         }

//         const newChangeListenerName = `selectChangeListener${Date.now()}_${optionName}`;
//         window[newChangeListenerName] = function() {
//             saveSelection(optionName, this.value);
//             console.log(`RejoesBuilder: Saved ${optionName}:`, this.value);
//             updateNextButtonState();
//         };

//         selectElement.addEventListener("change", window[newChangeListenerName]);
//         selectElement.setAttribute('data-listener-ref', newChangeListenerName);
//     });

//     function updateNextButtonState() {
//         const allSelected = Array.from(sizeSelectors).every(select => select.value !== '');
        
//         if (allSelected) {
//             nextBtn.removeAttribute('disabled');
//         } else {
//             nextBtn.setAttribute('disabled', 'disabled');
//         }
//     }

//     updateNextButtonState();

//     const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//     if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//         nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//         delete window[oldNextBtnListenerRef];
//     }

//     const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_3`;
//     window[newNextBtnListenerName] = function() {
//         if (Array.from(sizeSelectors).every(select => select.value !== '')) {
//             console.log("RejoesBuilder: Next button clicked in Step 3. Proceeding to Step 4.");
//             showStep(4);
//         } else {
//             alert('Please select all sizes to proceed.');
//             console.warn("RejoesBuilder: Attempted to proceed from Step 3 without selecting all sizes.");
//         }
//     };

//     nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//     nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
// }

// function initStep5(sectionElement) {
//     const addToCartBtn = sectionElement.querySelector('#mf-add-to-cart-btn');
//     const oldAddToCartListenerRef = addToCartBtn.getAttribute('data-listener-ref');

//     if (oldAddToCartListenerRef && window[oldAddToCartListenerRef]) {
//         addToCartBtn.removeEventListener('click', window[oldAddToCartListenerRef]);
//         delete window[oldAddToCartListenerRef];
//     }

//     const newAddToCartListenerName = `addToCartHandler${Date.now()}`;
//     window[newAddToCartListenerName] = async (e) => {
//         e.preventDefault();
//         addToCartBtn.textContent = 'Adding...';
//         addToCartBtn.setAttribute('disabled', 'disabled');

//         // Use your single variant ID here
//         const baseProductVariantId = 51583101337943; // Replace with your actual single variant ID

//         if (!baseProductVariantId) {
//             alert('Cannot add to cart: Product variant not configured.');
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//             return;
//         }

//         const properties = {
//             "Fit Type": getSelection('fitType'),
//             "Top Size": getSelection('top_size'),
//             "Jeans Waist": getSelection('jeans_waist'),
//             "Jeans Length": getSelection('jeans_length'),
//             "Sport Bottoms": getSelection('sport_bottoms'),
//             "Shoe Size": getSelection('shoes_size'),
//             "Bag Type": getSelection('bagType'),
//         };

//         const success = await handleAddToCart(baseProductVariantId, properties, addToCartBtn);

//         if (!success) {
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//         }
//     };

//     addToCartBtn.addEventListener('click', window[newAddToCartListenerName]);
//     addToCartBtn.setAttribute('data-listener-ref', newAddToCartListenerName);
// }

//     function initStep4(sectionElement) {
//         const bagTypeOptions = sectionElement.querySelectorAll('.mf-step4-bag-type-option');
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedBagType = getSelection('bagType');

//         // Initialize UI based on stored selections
//         if (selectedBagType) {
//             bagTypeOptions.forEach(option => {
//                 const variantTitle = option.dataset.variantTitle;

//                 if (variantTitle === selectedBagType) {
//                     option.classList.add('active');
//                     const radioInput = option.querySelector('input[type="radio"]');
//                     if (radioInput) radioInput.checked = true;
//                 } else {
//                     option.classList.remove('active');
//                     const radioInput = option.querySelector('input[type="radio"]'); // Ensure other radios are unchecked
//                     if (radioInput) radioInput.checked = false;
//                 }
//             });
//             nextBtn.removeAttribute('disabled');
//         } else {
//             // FIX: Explicitly deactivate and uncheck all options when no selection is found
//             bagTypeOptions.forEach(option => {
//                 option.classList.remove('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = false;
//             });
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         bagTypeOptions.forEach(option => {
//             const oldClickListenerRef = option.getAttribute('data-listener-ref');
//             if (oldClickListenerRef && window[oldClickListenerRef]) {
//                 option.removeEventListener('click', window[oldClickListenerRef]);
//                 delete window[oldClickListenerRef];
//             }

//             const newClickListenerName = `optionClickHandler${Date.now()}_${(option.dataset.variantTitle || '').replace(/\s+/g, '')}`;
//             window[newClickListenerName] = function() {
//                 bagTypeOptions.forEach(opt => {
//                     opt.classList.remove('active');
//                     const radioInput = opt.querySelector('input[type="radio"]');
//                     if (radioInput) radioInput.checked = false;
//                 });

//                 option.classList.add('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = true;

//                 const variantTitle = option.dataset.variantTitle;

//                 if (variantTitle && variantTitle.trim() !== '') {
//                     saveSelection('bagType', variantTitle);
//                     clearPrefixedSelection('selectedBagOptionVariantId');
//                     nextBtn.removeAttribute('disabled');
//                     console.log(`RejoesBuilder: Bag Type selected and saved: ${variantTitle}`);
//                 } else {
//                     console.warn('RejoesBuilder: Bag Type option has an invalid or empty data-variant-title attribute:', option);
//                     alert('Error: Selected bag type is invalid. Please ensure your template has a data-variant-title attribute with a valid value for each option.');
//                     clearPrefixedSelection('bagType');
//                     nextBtn.setAttribute('disabled', 'disabled');
//                 }
//             };

//             option.addEventListener('click', window[newClickListenerName]);
//             option.setAttribute('data-listener-ref', newClickListenerName);
//         });

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_4`;
//         window[newNextBtnListenerName] = function() {
//             if (getSelection('bagType')) {
//                 showStep(5);
//             } else {
//                 alert('Please select a bag type to continue.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     // function initStep5(sectionElement) {
//     //     const addToCartBtn = sectionElement.querySelector('#mf-add-to-cart-btn');
//     //     const oldAddToCartListenerRef = addToCartBtn.getAttribute('data-listener-ref');

//     //     if (oldAddToCartListenerRef && window[oldAddToCartListenerRef]) {
//     //         addToCartBtn.removeEventListener('click', window[oldAddToCartListenerRef]);
//     //         delete window[oldAddToCartListenerRef];
//     //     }

//     //     const newAddToCartListenerName = `addToCartHandler${Date.now()}`;
//     //     // FIX: Changed newAddToCartHandlerName to newAddToCartListenerName
//     //     window[newAddToCartListenerName] = async (e) => {
//     //         e.preventDefault();
//     //         addToCartBtn.textContent = 'Adding...';
//     //         addToCartBtn.setAttribute('disabled', 'disabled');

//     //         const baseProductVariantId = getSelection('selectedCartVariantId');

//     //         if (!baseProductVariantId) {
//     //             alert('Cannot add to cart: Base product variant not selected or found (from Step 3).');
//     //             addToCartBtn.textContent = 'CONTINUE';
//     //             addToCartBtn.removeAttribute('disabled');
//     //             return;
//     //         }

//     //         const properties = {
//     //             "Fit Type": getSelection('fitType'),
//     //             "Top Size": getSelection('top_size'),
//     //             "Bottom Size": getSelection('bottom_size'),
//     //             "Shoe Size": getSelection('shoe_size'),
//     //             "Bag Type": getSelection('bagType'),
//     //         };

//     //         const success = await handleAddToCart(baseProductVariantId, properties, addToCartBtn);

//     //         if (!success) {
//     //             addToCartBtn.textContent = 'CONTINUE';
//     //             addToCartBtn.removeAttribute('disabled');
//     //         }
//     //     };

//     //     addToCartBtn.addEventListener('click', window[newAddToCartListenerName]);
//     //     addToCartBtn.setAttribute('data-listener-ref', newAddToCartListenerName);
//     // }

//     // Remove the first initStep5 function definition.
// // Keep and modify this one:

// function initStep5(sectionElement) {
//     const addToCartBtn = sectionElement.querySelector('#mf-add-to-cart-btn');
//     const oldAddToCartListenerRef = addToCartBtn.getAttribute('data-listener-ref');

//     if (oldAddToCartListenerRef && window[oldAddToCartListenerRef]) {
//         addToCartBtn.removeEventListener('click', window[oldAddToCartListenerRef]);
//         delete window[oldAddToCartListenerRef];
//     }

//     const newAddToCartListenerName = `addToCartHandler${Date.now()}`;
//     window[newAddToCartListenerName] = async (e) => {
//         e.preventDefault();
//         addToCartBtn.textContent = 'Adding...';
//         addToCartBtn.setAttribute('disabled', 'disabled');

//         // IMPORTANT: Replace '10252343411031' with the actual Shopify Variant ID
//         // of your base "Mystery Fits" product. This is the single product variant
//         // to which all selected sizes will be attached as line item properties.
//         const baseProductVariantId = 51583101337943; // <<<--- UPDATE THIS ID

//         if (!baseProductVariantId) {
//             alert('Cannot add to cart: Base product variant ID is missing. Please ensure it is configured in the script.');
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//             return;
//         }

//         const properties = {
//             "Fit Type": getSelection('fitType'),
//             "Top Size": getSelection('top_size'),
//             "Jeans Waist": getSelection('jeans_waist'),
//             "Jeans Length": getSelection('jeans_length'),
//             "Sport Bottoms": getSelection('sport_bottoms'),
//             "Shoe Size": getSelection('shoes_size'),
//             "Bag Type": getSelection('bagType'),
//             // Add any other properties here if you collect them in other steps
//         };

//         const success = await handleAddToCart(baseProductVariantId, properties, addToCartBtn);

//         if (!success) {
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//         }
//     };

//     addToCartBtn.addEventListener('click', window[newAddToCartListenerName]);
//     addToCartBtn.setAttribute('data-listener-ref', newAddToCartListenerName);
// }

//     function initBuilder() {
//         const allStepSections = document.querySelectorAll('.mf-builder-step-section');

//         if (allStepSections.length === 0) {
//             console.warn('RejoesBuilder: No .mf-builder-step-section found. Ensure your sections have this class.');
//             return;
//         }

//         checkAndClearSelectionsIfNeeded();
        
//         document.querySelectorAll('.mf-builder-step-section').forEach(section => {
//             section.style.display = 'none';
//         });

//         showStep(1);
        
//         if (window.location.hash) {
//             window.history.replaceState(null, null, ' ');
//         }
//     }

//     return {
//         init: initBuilder,
//         showStep: showStep,
//         saveSelection: saveSelection,
//         getSelection: getSelection,
//         clearAllSelections: clearAllSelections
//     };
// })();

// document.addEventListener('DOMContentLoaded', () => {
//     RejoesBuilder.init();
// });




// const RejoesBuilder = (() => {
//     const STORAGE_KEY_PREFIX = 'rejoes_mf_';
//     let _selectedInspoFile = null;

//     function checkAndClearSelectionsIfNeeded() {
//         const hasJustCompleted = sessionStorage.getItem('rejoes_mf_just_completed');
        
//         if (hasJustCompleted || !window.location.href.includes('#')) {
//             clearAllSelections();
//             sessionStorage.removeItem('rejoes_mf_just_completed');
//             return true;
//         }
//         return false;
//     }

//     function saveSelection(key, value) {
//         sessionStorage.setItem(STORAGE_KEY_PREFIX + key, JSON.stringify(value));
//     }

//     function getSelection(key) {
//         const stored = sessionStorage.getItem(STORAGE_KEY_PREFIX + key);
//         try {
//             return stored ? JSON.parse(stored) : null;
//         } catch (e) {
//             console.error(`Error parsing sessionStorage key "${STORAGE_KEY_PREFIX + key}":`, e);
//             return null;
//         }
//     }

//     function clearPrefixedSelection(key) {
//         sessionStorage.removeItem(STORAGE_KEY_PREFIX + key);
//     }

//     function clearAllSelections() {
//         for (let i = 0; i < sessionStorage.length; i++) {
//             const key = sessionStorage.key(i);
//             if (key.startsWith(STORAGE_KEY_PREFIX)) {
//                 sessionStorage.removeItem(key);
//                 i--;
//             }
//         }
//         _selectedInspoFile = null;
//         console.log("All Rejoes Mystery Fits selections cleared.");
//     }

//     function showStep(stepNumber) {
//         const targetSection = document.querySelector(`.mf-builder-step-section[data-step="${stepNumber}"]`);
//         if (targetSection) {
//             document.querySelectorAll('.mf-builder-step-section').forEach(section => {
//                 section.style.display = 'none';
//             });
            
//             targetSection.style.display = 'block';
            
//             initStepLogic(stepNumber, targetSection);
//             window.history.pushState(null, '', `#step-${stepNumber}`);
//             console.log(`RejoesBuilder: Showing step ${stepNumber}.`);

//             setTimeout(() => {
//                 targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//             }, 100);

//             if (stepNumber === 5) {
//                 populateOrderSummary();
//             }
//         } else {
//             console.error(`RejoesBuilder: Step ${stepNumber} section not found. Falling back to Step 1.`);
//             window.history.pushState(null, '', `#step-1`);
//             showStep(1);
//         }
//     }

//     window.addEventListener('popstate', () => {
//         const hash = window.location.hash;
//         const stepNumber = hash ? parseInt(hash.replace('#step-', '')) : 1;
//         showStep(stepNumber);
//     });

//     async function handleAddToCart(variantId, properties, addToCartBtn) {
//         addToCartBtn.textContent = 'Adding...';
//         addToCartBtn.setAttribute('disabled', 'disabled');

//         const formData = new FormData();
//         formData.append('id', variantId);
//         formData.append('quantity', 1);

//         for (const key in properties) {
//             if (properties.hasOwnProperty(key) && properties[key] !== null && properties[key] !== 'null' && properties[key] !== '') {
//                 if (key !== "Inspo Image URL") {
//                     formData.append(`properties[${key}]`, properties[key]);
//                 }
//             }
//         }

//         if (_selectedInspoFile) {
//             formData.append('properties[Inspo Image]', _selectedInspoFile, _selectedInspoFile.name);
//         } else {
//             formData.append('properties[Inspo Image]', 'No image uploaded');
//         }

//         try {
//             const response = await fetch('/cart/add.js', {
//                 method: 'POST',
//                 body: formData
//             });

//             const data = await response.json();

//             if (data.status) {
//                 console.error('Add to cart error:', data.description);
//                 alert('Error adding item to cart: ' + data.description);
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//                 return false;
//             } else {
//                 console.log('Item added to cart:', data);
//                 sessionStorage.setItem('rejoes_mf_just_completed', 'true');
//                 clearAllSelections();
//                 window.location.href = '/cart';
//                 return true;
//             }
//         } catch (error) {
//             console.error('Network or unexpected error:', error);
//             alert('Could not add item to cart. Please try again.');
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//             return false;
//         }
//     }

//     function populateOrderSummary() {
//         const summarySection = document.querySelector('.mf-builder-step-section[data-step="5"]');
//         if (!summarySection) return;

//         const fitType = getSelection('fitType') || 'N/A';

//         const topSize = getSelection('top_size') || 'N/A';
//         const jeansWaist = getSelection('jeans_waist') || 'N/A';
//         const jeansLength = getSelection('jeans_length') || 'N/A';
//         const sportBottoms = getSelection('sport_bottoms') || 'N/A';
//         const shoesSize = getSelection('shoes_size') || 'N/A';

//         const bagType = getSelection('bagType') || 'N/A';
//         const inspoFileNameStored = getSelection('inspoFileName'); 

//         const selectedSizes = [];
//         if (topSize !== 'N/A') selectedSizes.push(`Top: ${topSize}`);
//         if (jeansWaist !== 'N/A' || jeansLength !== 'N/A') selectedSizes.push(`Jeans: ${jeansWaist}/${jeansLength}`);
//         if (sportBottoms !== 'N/A') selectedSizes.push(`Sport Bottoms: ${sportBottoms}`);
//         if (shoesSize !== 'N/A') selectedSizes.push(`Shoes: EU ${shoesSize}`);

//         const fitSizeDisplay = selectedSizes.length > 0 ? selectedSizes.join(', ') : 'N/A';

//         const fitTypeElement = summarySection.querySelector('[data-summary-field="fit-type"]');
//         if (fitTypeElement) fitTypeElement.textContent = fitType;

//         const fitSizeElement = summarySection.querySelector('[data-summary-field="fit-size"]');
//         if (fitSizeElement) fitSizeElement.textContent = fitSizeDisplay;

//         const bagTypeElement = summarySection.querySelector('[data-summary-field="bag-type"]');
//         if (bagTypeElement) bagTypeElement.textContent = bagType;

//         const inspoImageElement = summarySection.querySelector('[data-summary-field="inspo-image"]');
//         if (inspoImageElement) {
//             if (_selectedInspoFile || (inspoFileNameStored && inspoFileNameStored !== 'None')) {
//                 inspoImageElement.textContent = '✅'; 
//             } else {
//                 inspoImageElement.textContent = '❌'; 
//             }
//         }

//         console.log('RejoesBuilder: Order summary populated with:', {
//             fitType,
//             fitSize: fitSizeDisplay,
//             bagType,
//             inspoFileName: (_selectedInspoFile || (inspoFileNameStored && inspoFileNameStored !== 'None')) ? '✅' : '❌'
//         });
//     }

//     function initStepLogic(stepNumber, sectionElement) {
//         const goBackButton = sectionElement.querySelector('#mf-go-back-btn');
//         if (goBackButton) {
//             const oldListenerRef = goBackButton.getAttribute('data-listener-ref');
//             if (oldListenerRef && window[oldListenerRef]) {
//                 goBackButton.removeEventListener('click', window[oldListenerRef]);
//                 delete window[oldListenerRef];
//             }

//             const newGoBackHandlerName = `goBackHandler${Date.now()}_${stepNumber}`;
//             window[newGoBackHandlerName] = () => {
//                 if (stepNumber > 1) {
//                     showStep(stepNumber - 1);
//                 } else {
//                     console.log("RejoesBuilder: Already on Step 1, cannot go back further.");
//                 }
//             };

//             goBackButton.addEventListener('click', window[newGoBackHandlerName]);
//             goBackButton.setAttribute('data-listener-ref', newGoBackHandlerName);
//         }

//         switch (stepNumber) {
//             case 1: initStep1(sectionElement); break;
//             case 2: initStep2(sectionElement); break;
//             case 3: initStep3(sectionElement); break;
//             case 4: initStep4(sectionElement); break;
//             case 5: initStep5(sectionElement); break;
//             default: console.warn(`RejoesBuilder: No specific initializer for step ${stepNumber}`);
//         }
//     }

//     function initStep1(sectionElement) {
//         const radioGroup = sectionElement.querySelector('.radio-group');
//         const choiceLabels = radioGroup ? radioGroup.querySelectorAll('input[type="radio"] + label') : [];
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedFitType = getSelection('fitType');

//         if (selectedFitType) {
//             choiceLabels.forEach(label => {
//                 if (label.dataset.value === selectedFitType) {
//                     label.previousElementSibling.checked = true;
//                     label.classList.add('active');
//                 } else {
//                     label.classList.remove('active');
//                 }
//             });
//             nextBtn.removeAttribute('disabled');
//         } else {
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         choiceLabels.forEach(label => {
//             const oldLabelClickListenerRef = label.getAttribute('data-listener-ref');
//             if (oldLabelClickListenerRef && window[oldLabelClickListenerRef]) {
//                 label.removeEventListener('click', window[oldLabelClickListenerRef]);
//                 delete window[oldLabelClickListenerRef];
//             }

//             const newLabelClickHandlerName = `labelClickHandler${Date.now()}_${label.dataset.value.replace(/\s+/g, '')}`;
//             window[newLabelClickHandlerName] = () => {
//                 choiceLabels.forEach(l => l.classList.remove('active'));
//                 label.classList.add('active');
//                 saveSelection('fitType', label.dataset.value);
//                 nextBtn.removeAttribute('disabled');
//             };

//             label.addEventListener('click', window[newLabelClickHandlerName]);
//             label.setAttribute('data-listener-ref', newLabelClickHandlerName);
//         });

//         const oldNextBtnClickListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnClickListenerRef && window[oldNextBtnClickListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnClickListenerRef]);
//             delete window[oldNextBtnClickListenerRef];
//         }

//         const newNextBtnClickHandlerName = `nextBtnClickHandler${Date.now()}_1`;
//         window[newNextBtnClickHandlerName] = () => {
//             if (getSelection('fitType')) {
//                 showStep(2);
//             } else {
//                 alert('Please select a gender fit to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnClickHandlerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnClickHandlerName);
//     }

//     function initStep2(sectionElement) {
//         const fileInput = sectionElement.querySelector('#mf-step2-inspo-upload');
//         const dropzoneContainer = sectionElement.querySelector(".mf-step2-dropzone-container");
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

//         const uploadPrompt = sectionElement.querySelector('#mf-step2-upload-prompt');
//         const uploadPreview = sectionElement.querySelector('#mf-step2-upload-preview');
//         const previewImage = sectionElement.querySelector('#mf-step2-preview-image');
//         const previewFilename = sectionElement.querySelector('#mf-step2-preview-filename');
//         const previewStatus = sectionElement.querySelector('#mf-step2-preview-status');
//         const removeFileBtn = sectionElement.querySelector('#mf-step2-remove-file-btn');

//         function updateFileState(file) {
//             _selectedInspoFile = file;

//             if (file) {
//                 const localPreviewUrl = URL.createObjectURL(file);
//                 uploadPrompt.classList.add('hidden');
//                 uploadPreview.classList.remove('hidden');
//                 previewImage.src = localPreviewUrl;
//                 // previewFilename.textContent = file.name;
//                  previewFilename.textContent = '✅'; 
//                 previewStatus.textContent = 'File selected';
//                 nextBtn.removeAttribute('disabled');

//                 saveSelection('inspoFileName', file.name);
//                 saveSelection('inspoImageUrl', localPreviewUrl);
//             } else {
//                 uploadPrompt.classList.remove('hidden');
//                 uploadPreview.classList.add('hidden');
//                 previewImage.src = '';
//                 // previewFilename.textContent = '';
//                  previewFilename.textContent = '❌';
//                 previewStatus.textContent = 'No file selected';
//                 nextBtn.setAttribute('disabled', 'disabled');
                
//                 clearPrefixedSelection('inspoFileName');
//                 clearPrefixedSelection('inspoImageUrl');
//                 if (fileInput) fileInput.value = '';
//             }
//         }

//         if (_selectedInspoFile) {
//             updateFileState(_selectedInspoFile);
//         } else if (getSelection('inspoFileName')) {
//             uploadPrompt.classList.add('hidden');
//             uploadPreview.classList.remove('hidden');
//             previewImage.src = getSelection('inspoImageUrl') || 'https://via.placeholder.com/150?text=No+Preview';
//             previewFilename.textContent = getSelection('inspoFileName');
//             previewStatus.textContent = 'File previously selected (re-upload to include in order)';
//             nextBtn.setAttribute('disabled', 'disabled');
//         } else {
//             updateFileState(null);
//         }

//         const oldFileInputListenerRef = fileInput.getAttribute('data-listener-ref');
//         if (oldFileInputListenerRef && window[oldFileInputListenerRef]) {
//             fileInput.removeEventListener('change', window[oldFileInputListenerRef]);
//             delete window[oldFileInputListenerRef];
//         }

//         const oldDropoverListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragover');
//         if (oldDropoverListenerRef && window[oldDropoverListenerRef]) {
//             dropzoneContainer.removeEventListener('dragover', window[oldDropoverListenerRef]);
//             delete window[oldDropoverListenerRef];
//         }

//         const oldDragleaveListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragleave');
//         if (oldDragleaveListenerRef && window[oldDragleaveListenerRef]) {
//             dropzoneContainer.removeEventListener('dragleave', window[oldDragleaveListenerRef]);
//             delete window[oldDragleaveListenerRef];
//         }

//         const oldDropListenerRef = dropzoneContainer.getAttribute('data-listener-ref-drop');
//         if (oldDropListenerRef && window[oldDropListenerRef]) {
//             dropzoneContainer.removeEventListener('drop', window[oldDropListenerRef]);
//             delete window[oldDropListenerRef];
//         }

//         const oldRemoveFileListenerRef = removeFileBtn.getAttribute('data-listener-ref');
//         if (oldRemoveFileListenerRef && window[oldRemoveFileListenerRef]) {
//             removeFileBtn.removeEventListener('click', window[oldRemoveFileListenerRef]);
//             delete window[oldRemoveFileListenerRef];
//         }

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const handleFileRemove = () => {
//             fileInput.value = '';
//             updateFileState(null);
//         };

//         const newFileInputListenerName = `fileInputHandler${Date.now()}`;
//         window[newFileInputListenerName] = function(event) {
//             const file = event.target.files[0];
//             if (!file) {
//                 handleFileRemove();
//                 return;
//             }

//         const maxSize = 10 * 1024 * 1024; 
//             if (file.size > maxSize) {
//                 alert('File is too large. Maximum size is 10MB.'); 
//                 handleFileRemove();
//                 return;
//             }

//             updateFileState(file);
//             console.log("RejoesBuilder: File selected for Uploadery:", file.name);
//         };

//         fileInput.addEventListener("change", window[newFileInputListenerName]);
//         fileInput.setAttribute('data-listener-ref', newFileInputListenerName);

//         const newDragoverListenerName = `dragoverHandler${Date.now()}`;
//         window[newDragoverListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.add("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragover", window[newDragoverListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragover', newDragoverListenerName);

//         const newDragleaveListenerName = `dragleaveHandler${Date.now()}`;
//         window[newDragleaveListenerName] = function(event) {
//             dropzoneContainer.classList.remove("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragleave", window[newDragleaveListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragleave', newDragleaveListenerName);

//         const newDropListenerName = `dropHandler${Date.now()}`;
//         window[newDropListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.remove("drag-over");
//             const files = event.dataTransfer.files;
//             if (files.length > 0) {
//                 const dataTransfer = new DataTransfer();
//                 dataTransfer.items.add(files[0]);
//                 fileInput.files = dataTransfer.files;
//                 fileInput.dispatchEvent(new Event('change'));
//             }
//         };

//         dropzoneContainer.addEventListener("drop", window[newDropListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-drop', newDropListenerName);

//         const newRemoveFileListenerName = `removeFileHandler${Date.now()}`;
//         window[newRemoveFileListenerName] = handleFileRemove;

//         removeFileBtn.addEventListener('click', window[newRemoveFileListenerName]);
//         removeFileBtn.setAttribute('data-listener-ref', newRemoveFileListenerName);

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_2`;
//         window[newNextBtnListenerName] = function() {
//             if (_selectedInspoFile) {
//                 showStep(3);
//             } else {
//                 alert('Please upload an inspiration image to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep3(sectionElement) {
//         const sizeSelectors = sectionElement.querySelectorAll(".mf-step3-size-selector select");
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

//         sizeSelectors.forEach(selectElement => {
//             const optionName = selectElement.name;
//             let savedValue = getSelection(optionName);

//             if (savedValue) {
//                 selectElement.value = savedValue;
//             }

//             const oldChangeListenerRef = selectElement.getAttribute('data-listener-ref');
//             if (oldChangeListenerRef && window[oldChangeListenerRef]) {
//                 selectElement.removeEventListener('change', window[oldChangeListenerRef]);
//                 delete window[oldChangeListenerRef];
//             }

//             const newChangeListenerName = `selectChangeListener${Date.now()}_${optionName}`;
//             window[newChangeListenerName] = function() {
//                 saveSelection(optionName, this.value);
//                 console.log(`RejoesBuilder: Saved ${optionName}:`, this.value);
//                 updateNextButtonState();
//             };

//             selectElement.addEventListener("change", window[newChangeListenerName]);
//             selectElement.setAttribute('data-listener-ref', newChangeListenerName);
//         });

//         function updateNextButtonState() {
//             const allSelected = Array.from(sizeSelectors).every(select => select.value !== '');
            
//             if (allSelected) {
//                 nextBtn.removeAttribute('disabled');
//             } else {
//                 nextBtn.setAttribute('disabled', 'disabled');
//             }
//         }

//         updateNextButtonState();

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_3`;
//         window[newNextBtnListenerName] = function() {
//             if (Array.from(sizeSelectors).every(select => select.value !== '')) {
//                 console.log("RejoesBuilder: Next button clicked in Step 3. Proceeding to Step 4.");
//                 showStep(4);
//             } else {
//                 alert('Please select all sizes to proceed.');
//                 console.warn("RejoesBuilder: Attempted to proceed from Step 3 without selecting all sizes.");
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep4(sectionElement) {
//         const bagTypeOptions = sectionElement.querySelectorAll('.mf-step4-bag-type-option');
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedBagType = getSelection('bagType');

//         // Initialize UI based on stored selections
//         if (selectedBagType) {
//             bagTypeOptions.forEach(option => {
//                 const variantTitle = option.dataset.variantTitle;

//                 if (variantTitle === selectedBagType) {
//                     option.classList.add('active');
//                     const radioInput = option.querySelector('input[type="radio"]');
//                     if (radioInput) radioInput.checked = true;
//                 } else {
//                     option.classList.remove('active');
//                     const radioInput = option.querySelector('input[type="radio"]'); // Ensure other radios are unchecked
//                     if (radioInput) radioInput.checked = false;
//                 }
//             });
//             nextBtn.removeAttribute('disabled');
//         } else {
//             // Explicitly deactivate and uncheck all options when no selection is found
//             bagTypeOptions.forEach(option => {
//                 option.classList.remove('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = false;
//             });
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         bagTypeOptions.forEach(option => {
//             const oldClickListenerRef = option.getAttribute('data-listener-ref');
//             if (oldClickListenerRef && window[oldClickListenerRef]) {
//                 option.removeEventListener('click', window[oldClickListenerRef]);
//                 delete window[oldClickListenerRef];
//             }

//             const newClickListenerName = `optionClickHandler${Date.now()}_${(option.dataset.variantTitle || '').replace(/\s+/g, '')}`;
//             window[newClickListenerName] = function() {
//                 bagTypeOptions.forEach(opt => {
//                     opt.classList.remove('active');
//                     const radioInput = opt.querySelector('input[type="radio"]');
//                     if (radioInput) radioInput.checked = false;
//                 });

//                 option.classList.add('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = true;

//                 const variantTitle = option.dataset.variantTitle;

//                 if (variantTitle && variantTitle.trim() !== '') {
//                     saveSelection('bagType', variantTitle);
//                     clearPrefixedSelection('selectedBagOptionVariantId'); // This was not strictly needed, but kept for consistency if ever used
//                     nextBtn.removeAttribute('disabled');
//                     console.log(`RejoesBuilder: Bag Type selected and saved: ${variantTitle}`);
//                 } else {
//                     console.warn('RejoesBuilder: Bag Type option has an invalid or empty data-variant-title attribute:', option);
//                     alert('Error: Selected bag type is invalid. Please ensure your template has a data-variant-title attribute with a valid value for each option.');
//                     clearPrefixedSelection('bagType');
//                     nextBtn.setAttribute('disabled', 'disabled');
//                 }
//             };

//             option.addEventListener('click', window[newClickListenerName]);
//             option.setAttribute('data-listener-ref', newClickListenerName);
//         });

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_4`;
//         window[newNextBtnListenerName] = function() {
//             if (getSelection('bagType')) {
//                 showStep(5);
//             } else {
//                 alert('Please select a bag type to continue.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep5(sectionElement) {
//         const addToCartBtn = sectionElement.querySelector('#mf-add-to-cart-btn');
//         const oldAddToCartListenerRef = addToCartBtn.getAttribute('data-listener-ref');

//         if (oldAddToCartListenerRef && window[oldAddToCartListenerRef]) {
//             addToCartBtn.removeEventListener('click', window[oldAddToCartListenerRef]);
//             delete window[oldAddToCartListenerRef];
//         }

//         const newAddToCartListenerName = `addToCartHandler${Date.now()}`;
//         window[newAddToCartListenerName] = async (e) => {
//             e.preventDefault();
//             addToCartBtn.textContent = 'Adding...';
//             addToCartBtn.setAttribute('disabled', 'disabled');

//             // --- IMPORTANT: This is the variant ID you confirmed for your base product ---
//             const baseProductVariantId = 51583101337943; 

//             if (!baseProductVariantId) {
//                 alert('Cannot add to cart: Base product variant ID is missing. Please ensure it is configured in the script.');
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//                 return;
//             }

//             const properties = {
//                 "Fit Type": getSelection('fitType'),
//                 "Top Size": getSelection('top_size'),
//                 "Jeans Waist": getSelection('jeans_waist'),
//                 "Jeans Length": getSelection('jeans_length'),
//                 "Sport Bottoms": getSelection('sport_bottoms'),
//                 "Shoe Size": getSelection('shoes_size'),
//                 "Bag Type": getSelection('bagType'),
//             };

//             const success = await handleAddToCart(baseProductVariantId, properties, addToCartBtn);

//             if (!success) {
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//             }
//         };

//         addToCartBtn.addEventListener('click', window[newAddToCartListenerName]);
//         addToCartBtn.setAttribute('data-listener-ref', newAddToCartListenerName);
//     }

//     function initBuilder() {
//         const allStepSections = document.querySelectorAll('.mf-builder-step-section');

//         if (allStepSections.length === 0) {
//             console.warn('RejoesBuilder: No .mf-builder-step-section found. Ensure your sections have this class.');
//             return;
//         }

//         checkAndClearSelectionsIfNeeded();
        
//         document.querySelectorAll('.mf-builder-step-section').forEach(section => {
//             section.style.display = 'none';
//         });

//         showStep(1);
        
//         if (window.location.hash) {
//             window.history.replaceState(null, null, ' ');
//         }
//     }

//     return {
//         init: initBuilder,
//         showStep: showStep,
//         saveSelection: saveSelection,
//         getSelection: getSelection,
//         clearAllSelections: clearAllSelections
//     };
// })();

// document.addEventListener('DOMContentLoaded', () => {
//     RejoesBuilder.init();
// });


// const RejoesBuilder = (() => {
//     const STORAGE_KEY_PREFIX = 'rejoes_mf_';
//     let _selectedInspoFile = null;

//     let _builderProductData = {
//         variants: [] // Dynamically populated from Shopify
//     }; 

//     //     async function loadBuilderProductData(sectionElement) {
//     //     const productHandle = sectionElement.dataset.productHandle;
//     //     if (!productHandle) {
//     //         console.error("RejoesBuilder: No product handle found for builder product. Please configure 'Builder Base Product' in section settings for Step 4.");
//     //         // Fallback: If no product handle is set, use hardcoded prices/IDs
//     //         _builderProductData.variants = [
//     //             { title: "The Classic", id: 51583101337943, price: 2999, formatted_price: "€29,99" }, 
//     //             { title: "The Plus", id: 51583101337944, price: 3799, formatted_price: "€37,99" },
//     //             { title: "The Full Drip", id: 51583101337945, price: 5999, formatted_price: "€59,99" }
//     //         ];
//     //         return;
//     //     }

//     //     try {
//     //         const response = await fetch(`/products/${productHandle}.js`);
//     //         if (!response.ok) {
//     //             throw new Error(`HTTP error! status: ${response.status}`);
//     //         }
//     //         const product = await response.json();

//     //         _builderProductData.variants = product.variants.map(variant => {
//     //             let formattedPrice;
//     //             // Check if Shopify.formatMoney is available, otherwise use a fallback
//     //             if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
//     //                 // Assuming price is in cents, convert to dollars/euros for formatMoney
//     //                 // You might need to adjust 'variant.price / 100' based on your currency settings
//     //                 formattedPrice = Shopify.formatMoney(variant.price, window.Shopify.currency.format); // Use theme's default format
//     //             } else {
//     //                 // Fallback for manual formatting if Shopify.formatMoney is not available
//     //                 formattedPrice = `€${(variant.price / 100).toFixed(2).replace('.', ',')}`; // Basic Euro format
//     //                 console.warn("Shopify.formatMoney not found. Using basic manual price formatting.");
//     //             }

//     //             return {
//     //                 title: variant.title,
//     //                 id: variant.id,
//     //                 price: variant.price, // Keep price in cents
//     //                 formatted_price: formattedPrice // This will now be correctly formatted
//     //             };
//     //         });
//     //         console.log("RejoesBuilder: Dynamically loaded builder product data:", _builderProductData);

//     //     } catch (error) {
//     //         console.error("RejoesBuilder: Failed to load builder product data:", error);
//     //         // Fallback: If fetching fails, use hardcoded prices/IDs
//     //         _builderProductData.variants = [
//     //             { title: "The Classic", id: 51583101337943, price: 2999, formatted_price: "€29,99" }, 
//     //             { title: "The Plus", id: 51583101337944, price: 3799, formatted_price: "€37,99" },
//     //             { title: "The Full Drip", id: 51583101337945, price: 5999, formatted_price: "€59,99" }
//     //         ];
//     //     }
//     // }

//  async function loadBuilderProductData(sectionElement) {
//     const productHandle = sectionElement.dataset.productHandle;
//     if (!productHandle) {
//         console.error("RejoesBuilder: No product handle found for builder product. Please configure 'Builder Base Product' in section settings for Step 4.");
//         // Fallback: If no product handle is set, use hardcoded prices/IDs
//         _builderProductData.variants = [
//             { title: "The Classic", id: 51583101337943, price: 2999, formatted_price: "€29,99" }, 
//             { title: "The Plus", id: 51583101337944, price: 3799, formatted_price: "€37,99" },
//             { title: "The Full Drip", id: 51583101337945, price: 5999, formatted_price: "€59,99" }
//         ];
//         return;
//     }

//     try {
//         const response = await fetch(`/products/${productHandle}.js`);
//         if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const product = await response.json();

//         _builderProductData.variants = product.variants.map(variant => {
//             let formattedPrice;
//             // Check if Shopify.formatMoney is available, otherwise use a fallback
//             if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
//                 // Use Shopify's built-in currency formatting
//                 formattedPrice = Shopify.formatMoney(variant.price, window.money_format || window.Shopify.currency?.format || '{{amount}}');
//             } else {
//                 // Fallback for manual formatting if Shopify.formatMoney is not available
//                 // Use the store's default currency instead of hardcoding Euro
//                 const amount = (variant.price / 100).toFixed(2);
//                 const currencyCode = window.Shopify?.currency?.active || 'EUR';
                
//                 // Comprehensive currency symbols list
//                 const currencySymbols = {
//                     'USD': '$', 'EUR': '€', 'GBP': '£', 'JPY': '¥', 'CAD': 'C$', 'AUD': 'A$',
//                     'CHF': 'CHF', 'CNY': '¥', 'INR': '₹', 'BDT': '৳', 'RUB': '₽', 'KRW': '₩',
//                     'BRL': 'R$', 'MXN': '$', 'SGD': 'S$', 'NZD': 'NZ$', 'TRY': '₺', 'ZAR': 'R',
//                     'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'HKD': 'HK$', 'MYR': 'RM', 'PHP': '₱',
//                     'IDR': 'Rp', 'THB': '฿', 'VND': '₫', 'PLN': 'zł', 'CZK': 'Kč', 'HUF': 'Ft',
//                     'ILS': '₪', 'AED': 'د.إ', 'SAR': '﷼', 'QAR': 'ر.ق', 'KWD': 'د.ك', 'EGP': '£',
//                     // European countries you mentioned
//                     'BEL': '€',  // Belgium uses Euro
//                     'NLD': '€',  // Netherlands uses Euro
//                     'DEU': '€',  // Germany uses Euro
//                     'FRA': '€',  // France uses Euro
//                     'ESP': '€',  // Spain uses Euro
//                     'ITA': '€',  // Italy uses Euro
//                     'PRT': '€',  // Portugal uses Euro
//                     'AUT': '€',  // Austria uses Euro
//                     'FIN': '€',  // Finland uses Euro
//                     'GRC': '€',  // Greece uses Euro
//                     'IRL': '€',  // Ireland uses Euro
//                     // Other European countries with their own currencies
//                     'CHF': 'CHF', // Switzerland
//                     'DKK': 'kr',  // Denmark
//                     'NOK': 'kr',  // Norway
//                     'SEK': 'kr',  // Sweden
//                     'RON': 'lei', // Romania
//                     'HUF': 'Ft',  // Hungary
//                     'CZK': 'Kč',  // Czech Republic
//                     'PLN': 'zł',  // Poland
//                     'BGN': 'лв',  // Bulgaria
//                     'HRK': 'kn',  // Croatia
//                 };
                
//                 const symbol = currencySymbols[currencyCode] || currencyCode;
                
//                 // Format based on common currency formatting patterns
//                 if (currencyCode === 'EUR' || currencyCode === 'BEL' || currencyCode === 'NLD' || 
//                     currencyCode === 'DEU' || currencyCode === 'FRA' || currencyCode === 'ESP' || 
//                     currencyCode === 'ITA' || currencyCode === 'PRT') {
//                     formattedPrice = `€${amount.replace('.', ',')}`;
//                 } else if (currencyCode === 'BDT') {
//                     formattedPrice = `৳${amount}`;
//                 } else if (currencyCode === 'JPY' || currencyCode === 'CNY') {
//                     formattedPrice = `¥${amount}`;
//                 } else if (currencyCode === 'GBP') {
//                     formattedPrice = `£${amount}`;
//                 } else {
//                     formattedPrice = `${symbol}${amount}`;
//                 }
                
//                 console.warn("Shopify.formatMoney not found. Using basic manual price formatting.");
//             }

//             return {
//                 title: variant.title,
//                 id: variant.id,
//                 price: variant.price, // Keep price in cents
//                 formatted_price: formattedPrice // This will now be correctly formatted
//             };
//         });
//         console.log("RejoesBuilder: Dynamically loaded builder product data:", _builderProductData);

//     } catch (error) {
//         console.error("RejoesBuilder: Failed to load builder product data:", error);
//         // Fallback: If fetching fails, use hardcoded prices/IDs
//         _builderProductData.variants = [
//             { title: "The Classic", id: 51583101337943, price: 2999, formatted_price: "€29,99" }, 
//             { title: "The Plus", id: 51583101337944, price: 3799, formatted_price: "€37,99" },
//             { title: "The Full Drip", id: 51583101337945, price: 5999, formatted_price: "€59,99" }
//         ];
//     }
// }
//     function checkAndClearSelectionsIfNeeded() {
//         const hasJustCompleted = sessionStorage.getItem(STORAGE_KEY_PREFIX + 'just_completed');
        
//         if (hasJustCompleted || !window.location.href.includes('#')) {
//             clearAllSelections();
//             sessionStorage.removeItem(STORAGE_KEY_PREFIX + 'just_completed');
//             return true;
//         }
//         return false;
//     }

//     function saveSelection(key, value) {
//         sessionStorage.setItem(STORAGE_KEY_PREFIX + key, JSON.stringify(value));
//     }

//     function getSelection(key) {
//         const stored = sessionStorage.getItem(STORAGE_KEY_PREFIX + key);
//         try {
//             return stored ? JSON.parse(stored) : null;
//         } catch (e) {
//             console.error(`Error parsing sessionStorage key "${STORAGE_KEY_PREFIX + key}":`, e);
//             return null;
//         }
//     }

//     function clearPrefixedSelection(key) {
//         sessionStorage.removeItem(STORAGE_KEY_PREFIX + key);
//     }

//     function clearAllSelections() {
//         for (let i = 0; i < sessionStorage.length; i++) {
//             const key = sessionStorage.key(i);
//             if (key.startsWith(STORAGE_KEY_PREFIX)) {
//                 sessionStorage.removeItem(key);
//                 i--;
//             }
//         }
//         _selectedInspoFile = null;
//         console.log("All Rejoes Mystery Fits selections cleared.");
//     }

//     function showStep(stepNumber) {
//         const targetSection = document.querySelector(`.mf-builder-step-section[data-step="${stepNumber}"]`);
//         if (targetSection) {
//             document.querySelectorAll('.mf-builder-step-section').forEach(section => {
//                 section.style.display = 'none';
//             });
            
//             targetSection.style.display = 'block';
            
//             initStepLogic(stepNumber, targetSection);
//             window.history.pushState(null, '', `#step-${stepNumber}`);
//             console.log(`RejoesBuilder: Showing step ${stepNumber}.`);

//             setTimeout(() => {
//                 targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//             }, 100);

//             if (stepNumber === 5) {
//                 populateOrderSummary();
//             }
//         } else {
//             console.error(`RejoesBuilder: Step ${stepNumber} section not found. Falling back to Step 1.`);
//             window.history.pushState(null, '', `#step-1`);
//             showStep(1);
//         }
//     }

//     window.addEventListener('popstate', () => {
//         const hash = window.location.hash;
//         const stepNumber = hash ? parseInt(hash.replace('#step-', '')) : 1;
//         showStep(stepNumber);
//     });

//     async function handleAddToCart(variantId, properties, addToCartBtn) {
//         addToCartBtn.textContent = 'Adding...';
//         addToCartBtn.setAttribute('disabled', 'disabled');

//         const formData = new FormData();
//         formData.append('id', variantId);
//         formData.append('quantity', 1);

//         for (const key in properties) {
//             if (properties.hasOwnProperty(key) && properties[key] !== null && properties[key] !== 'null' && properties[key] !== '') {
//                 if (key !== "Inspo Image URL") {
//                     formData.append(`properties[${key}]`, properties[key]);
//                 }
//             }
//         }

//         if (_selectedInspoFile) {
//             formData.append('properties[Inspo Image]', _selectedInspoFile, _selectedInspoFile.name);
//         } else {
//             formData.append('properties[Inspo Image]', 'No image uploaded');
//         }

//         try {
//             const response = await fetch('/cart/add.js', {
//                 method: 'POST',
//                 body: formData
//             });

//             const data = await response.json();

//             if (data.status) {
//                 console.error('Add to cart error:', data.description);
//                 alert('Error adding item to cart: ' + data.description);
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//                 return false;
//             } else {
//                 console.log('Item added to cart:', data);
//                 sessionStorage.setItem(STORAGE_KEY_PREFIX + 'just_completed', 'true');
//                 clearAllSelections();
//                 window.location.href = '/cart';
//                 return true;
//             }
//         } catch (error) {
//             console.error('Network or unexpected error:', error);
//             alert('Could not add item to cart. Please try again.');
//             addToCartBtn.textContent = 'CONTINUE';
//             addToCartBtn.removeAttribute('disabled');
//             return false;
//         }
//     }

//     function populateOrderSummary() {
//         const summarySection = document.querySelector('.mf-builder-step-section[data-step="5"]');
//         if (!summarySection) return;

//         const fitType = getSelection('fitType') || 'N/A';

//         const topSize = getSelection('top_size') || 'N/A';
//         const jeansWaist = getSelection('jeans_waist') || 'N/A';
//         const jeansLength = getSelection('jeans_length') || 'N/A';
//         const sportBottoms = getSelection('sport_bottoms') || 'N/A';
//         const shoesSize = getSelection('shoes_size') || 'N/A';

//         const bagType = getSelection('bagType') || 'N/A';
//         const inspoFileNameStored = getSelection('inspoFileName'); 

//         const selectedSizes = [];
//         if (topSize !== 'N/A') selectedSizes.push(`Top: ${topSize}`);
//         if (jeansWaist !== 'N/A' || jeansLength !== 'N/A') selectedSizes.push(`Jeans: ${jeansWaist}/${jeansLength}`);
//         if (sportBottoms !== 'N/A') selectedSizes.push(`Sport Bottoms: ${sportBottoms}`);
//         if (shoesSize !== 'N/A') selectedSizes.push(`Shoes: EU ${shoesSize}`);

//         const fitSizeDisplay = selectedSizes.length > 0 ? selectedSizes.join(', ') : 'N/A';

//         const fitTypeElement = summarySection.querySelector('[data-summary-field="fit-type"]');
//         if (fitTypeElement) fitTypeElement.textContent = fitType;

//         const fitSizeElement = summarySection.querySelector('[data-summary-field="fit-size"]');
//         if (fitSizeElement) fitSizeElement.textContent = fitSizeDisplay;

//         const bagTypeElement = summarySection.querySelector('[data-summary-field="bag-type"]');
//         if (bagTypeElement) bagTypeElement.textContent = bagType;

//         const inspoImageElement = summarySection.querySelector('[data-summary-field="inspo-image"]');
//         if (inspoImageElement) {
//             if (_selectedInspoFile || (inspoFileNameStored && inspoFileNameStored !== 'None')) {
//                 inspoImageElement.textContent = '✅'; 
//             } else {
//                 inspoImageElement.textContent = '❌'; 
//             }
//         }

//         console.log('RejoesBuilder: Order summary populated with:', {
//             fitType,
//             fitSize: fitSizeDisplay,
//             bagType,
//             inspoFileName: (_selectedInspoFile || (inspoFileNameStored && inspoFileNameStored !== 'None')) ? '✅' : '❌'
//         });
//     }

//     function initStepLogic(stepNumber, sectionElement) {
//         const goBackButton = sectionElement.querySelector('#mf-go-back-btn');
//         if (goBackButton) {
//             const oldListenerRef = goBackButton.getAttribute('data-listener-ref');
//             if (oldListenerRef && window[oldListenerRef]) {
//                 goBackButton.removeEventListener('click', window[oldListenerRef]);
//                 delete window[oldListenerRef];
//             }

//             const newGoBackHandlerName = `goBackHandler${Date.now()}_${stepNumber}`;
//             window[newGoBackHandlerName] = () => {
//                 if (stepNumber > 1) {
//                     showStep(stepNumber - 1);
//                 } else {
//                     console.log("RejoesBuilder: Already on Step 1, cannot go back further.");
//                 }
//             };

//             goBackButton.addEventListener('click', window[newGoBackHandlerName]);
//             goBackButton.setAttribute('data-listener-ref', newGoBackHandlerName);
//         }

//         switch (stepNumber) {
//             case 1: initStep1(sectionElement); break;
//             case 2: initStep2(sectionElement); break;
//             case 3: initStep3(sectionElement); break;
//             case 4: initStep4(sectionElement); break;
//             case 5: initStep5(sectionElement); break;
//             default: console.warn(`RejoesBuilder: No specific initializer for step ${stepNumber}`);
//         }
//     }

//     function initStep1(sectionElement) {
//         const radioGroup = sectionElement.querySelector('.radio-group');
//         const choiceLabels = radioGroup ? radioGroup.querySelectorAll('input[type="radio"] + label') : [];
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedFitType = getSelection('fitType');

//         if (selectedFitType) {
//             choiceLabels.forEach(label => {
//                 if (label.dataset.value === selectedFitType) {
//                     label.previousElementSibling.checked = true;
//                     label.classList.add('active');
//                 } else {
//                     label.classList.remove('active');
//                 }
//             });
//             nextBtn.removeAttribute('disabled');
//         } else {
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         choiceLabels.forEach(label => {
//             const oldLabelClickListenerRef = label.getAttribute('data-listener-ref');
//             if (oldLabelClickListenerRef && window[oldLabelClickListenerRef]) {
//                 label.removeEventListener('click', window[oldLabelClickListenerRef]);
//                 delete window[oldLabelClickListenerRef];
//             }

//             const newLabelClickHandlerName = `labelClickHandler${Date.now()}_${label.dataset.value.replace(/\s+/g, '')}`;
//             window[newLabelClickHandlerName] = function() {
//                 choiceLabels.forEach(l => l.classList.remove('active'));
//                 label.classList.add('active');
//                 saveSelection('fitType', label.dataset.value);
//                 nextBtn.removeAttribute('disabled');
//             };

//             label.addEventListener('click', window[newLabelClickHandlerName]);
//             label.setAttribute('data-listener-ref', newLabelClickHandlerName);
//         });

//         const oldNextBtnClickListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnClickListenerRef && window[oldNextBtnClickListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnClickListenerRef]);
//             delete window[oldNextBtnClickListenerRef];
//         }

//         const newNextBtnClickHandlerName = `nextBtnClickHandler${Date.now()}_1`;
//         window[newNextBtnClickHandlerName] = () => {
//             if (getSelection('fitType')) {
//                 showStep(2);
//             } else {
//                 alert('Please select a gender fit to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnClickHandlerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnClickHandlerName);
//     }

//     function initStep2(sectionElement) {
//         const fileInput = sectionElement.querySelector('#mf-step2-inspo-upload');
//         const dropzoneContainer = sectionElement.querySelector(".mf-step2-dropzone-container");
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

//         const uploadPrompt = sectionElement.querySelector('#mf-step2-upload-prompt');
//         const uploadPreview = sectionElement.querySelector('#mf-step2-upload-preview');
//         const previewImage = sectionElement.querySelector('#mf-step2-preview-image');
//         const previewFilename = sectionElement.querySelector('#mf-step2-preview-filename');
//         const previewStatus = sectionElement.querySelector('#mf-step2-preview-status');
//         const removeFileBtn = sectionElement.querySelector('#mf-step2-remove-file-btn');

//         function updateFileState(file) {
//             _selectedInspoFile = file;

//             if (file) {
//                 const localPreviewUrl = URL.createObjectURL(file);
//                 uploadPrompt.classList.add('hidden');
//                 uploadPreview.classList.remove('hidden');
//                 previewImage.src = localPreviewUrl;
//                 previewFilename.textContent = '✅'; 
//                 previewStatus.textContent = 'File selected';
//                 nextBtn.removeAttribute('disabled');

//                 saveSelection('inspoFileName', file.name);
//                 saveSelection('inspoImageUrl', localPreviewUrl);
//             } else {
//                 uploadPrompt.classList.remove('hidden');
//                 uploadPreview.classList.add('hidden');
//                 previewImage.src = '';
//                 previewFilename.textContent = '❌';
//                 previewStatus.textContent = 'No file selected';
//                 nextBtn.setAttribute('disabled', 'disabled');
                
//                 clearPrefixedSelection('inspoFileName');
//                 clearPrefixedSelection('inspoImageUrl');
//                 if (fileInput) fileInput.value = '';
//             }
//         }

//         if (_selectedInspoFile) {
//             updateFileState(_selectedInspoFile);
//         } else if (getSelection('inspoFileName')) {
//             uploadPrompt.classList.add('hidden');
//             uploadPreview.classList.remove('hidden');
//             previewImage.src = getSelection('inspoImageUrl') || 'https://via.placeholder.com/150?text=No+Preview';
//             previewFilename.textContent = '✅'; // Updated to show '✅' for previously selected file too
//             previewStatus.textContent = 'File previously selected (re-upload to include in order)';
//             nextBtn.setAttribute('disabled', 'disabled');
//         } else {
//             updateFileState(null);
//         }

//         const oldFileInputListenerRef = fileInput.getAttribute('data-listener-ref');
//         if (oldFileInputListenerRef && window[oldFileInputListenerRef]) {
//             fileInput.removeEventListener('change', window[oldFileInputListenerRef]);
//             delete window[oldFileInputListenerRef];
//         }

//         const oldDropoverListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragover');
//         if (oldDropoverListenerRef && window[oldDropoverListenerRef]) {
//             dropzoneContainer.removeEventListener('dragover', window[oldDropoverListenerRef]);
//             delete window[oldDropoverListenerRef];
//         }

//         const oldDragleaveListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragleave');
//         if (oldDragleaveListenerRef && window[oldDragleaveListenerRef]) {
//             dropzoneContainer.removeEventListener('dragleave', window[oldDragleaveListenerRef]);
//             delete window[oldDragleaveListenerRef];
//         }

//         const oldDropListenerRef = dropzoneContainer.getAttribute('data-listener-ref-drop');
//         if (oldDropListenerRef && window[oldDropListenerRef]) {
//             dropzoneContainer.removeEventListener('drop', window[oldDropListenerRef]);
//             delete window[oldDropListenerRef];
//         }

//         const oldRemoveFileListenerRef = removeFileBtn.getAttribute('data-listener-ref');
//         if (oldRemoveFileListenerRef && window[oldRemoveFileListenerRef]) {
//             removeFileBtn.removeEventListener('click', window[oldRemoveFileListenerRef]);
//             delete window[oldRemoveFileListenerRef];
//         }

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const handleFileRemove = () => {
//             fileInput.value = '';
//             updateFileState(null);
//         };

//         const newFileInputListenerName = `fileInputHandler${Date.now()}`;
//         window[newFileInputListenerName] = function(event) {
//             const file = event.target.files[0];
//             if (!file) {
//                 handleFileRemove();
//                 return;
//             }

//         const maxSize = 10 * 1024 * 1024; 
//             if (file.size > maxSize) {
//                 alert('File is too large. Maximum size is 10MB.'); 
//                 handleFileRemove();
//                 return;
//             }

//             updateFileState(file);
//             console.log("RejoesBuilder: File selected for Uploadery:", file.name);
//         };

//         fileInput.addEventListener("change", window[newFileInputListenerName]);
//         fileInput.setAttribute('data-listener-ref', newFileInputListenerName);

//         const newDragoverListenerName = `dragoverHandler${Date.now()}`;
//         window[newDragoverListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.add("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragover", window[newDragoverListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragover', newDragoverListenerName);

//         const newDragleaveListenerName = `dragleaveHandler${Date.now()}`;
//         window[newDragleaveListenerName] = function(event) {
//             dropzoneContainer.classList.remove("drag-over");
//         };

//         dropzoneContainer.addEventListener("dragleave", window[newDragleaveListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-dragleave', newDragleaveListenerName);

//         const newDropListenerName = `dropHandler${Date.now()}`;
//         window[newDropListenerName] = function(event) {
//             event.preventDefault();
//             dropzoneContainer.classList.remove("drag-over");
//             const files = event.dataTransfer.files;
//             if (files.length > 0) {
//                 const dataTransfer = new DataTransfer();
//                 dataTransfer.items.add(files[0]);
//                 fileInput.files = dataTransfer.files;
//                 fileInput.dispatchEvent(new Event('change'));
//             }
//         };

//         dropzoneContainer.addEventListener("drop", window[newDropListenerName]);
//         dropzoneContainer.setAttribute('data-listener-ref-drop', newDropListenerName);

//         const newRemoveFileListenerName = `removeFileHandler${Date.now()}`;
//         window[newRemoveFileListenerName] = handleFileRemove;

//         removeFileBtn.addEventListener('click', window[newRemoveFileListenerName]);
//         removeFileBtn.setAttribute('data-listener-ref', newRemoveFileListenerName);

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_2`;
//         window[newNextBtnListenerName] = function() {
//             if (_selectedInspoFile) {
//                 showStep(3);
//             } else {
//                 alert('Please upload an inspiration image to proceed.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep3(sectionElement) {
//         const sizeSelectors = sectionElement.querySelectorAll(".mf-step3-size-selector select");
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

//         sizeSelectors.forEach(selectElement => {
//             const optionName = selectElement.name;
//             let savedValue = getSelection(optionName);

//             if (savedValue) {
//                 selectElement.value = savedValue;
//             }

//             const oldChangeListenerRef = selectElement.getAttribute('data-listener-ref');
//             if (oldChangeListenerRef && window[oldChangeListenerRef]) {
//                 selectElement.removeEventListener('change', window[oldChangeListenerRef]);
//                 delete window[oldChangeListenerRef];
//             }

//             const newChangeListenerName = `selectChangeListener${Date.now()}_${optionName}`;
//             window[newChangeListenerName] = function() {
//                 saveSelection(optionName, this.value);
//                 console.log(`RejoesBuilder: Saved ${optionName}:`, this.value);
//                 updateNextButtonState();
//             };

//             selectElement.addEventListener("change", window[newChangeListenerName]);
//             selectElement.setAttribute('data-listener-ref', newChangeListenerName);
//         });

//         function updateNextButtonState() {
//             const allSelected = Array.from(sizeSelectors).every(select => select.value !== '');
            
//             if (allSelected) {
//                 nextBtn.removeAttribute('disabled');
//             } else {
//                 nextBtn.setAttribute('disabled', 'disabled');
//             }
//         }

//         updateNextButtonState();

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_3`;
//         window[newNextBtnListenerName] = function() {
//             if (Array.from(sizeSelectors).every(select => select.value !== '')) {
//                 console.log("RejoesBuilder: Next button clicked in Step 3. Proceeding to Step 4.");
//                 showStep(4);
//             } else {
//                 alert('Please select all sizes to proceed.');
//                 console.warn("RejoesBuilder: Attempted to proceed from Step 3 without selecting all sizes.");
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep4(sectionElement) {
//         const bagTypeOptions = sectionElement.querySelectorAll('.mf-step4-bag-type-option');
//         const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
//         let selectedBagType = getSelection('bagType');
//         let selectedBagOptionVariantId = getSelection('selectedBagOptionVariantId');

//         const variantsMap = {};
//         if (_builderProductData.variants) {
//             _builderProductData.variants.forEach(variant => {
//                 variantsMap[variant.title] = variant;
//             });
//         }

//         bagTypeOptions.forEach(option => {
//             const variantTitle = option.dataset.variantTitle;
//             const priceSpan = option.querySelector('.mf-bag-type-price');
//             const variant = variantsMap[variantTitle];

//             if (priceSpan && variant) {
//                 priceSpan.textContent = variant.formatted_price;
//                 option.dataset.variantId = variant.id;
//             } else if (priceSpan) {
//                 priceSpan.textContent = 'Error: Price N/A'; // Show error if variant data is missing
//             }

//             if (variantTitle === selectedBagType) {
//                 option.classList.add('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = true;
//             } else {
//                 option.classList.remove('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = false;
//             }
//         });

//         if (selectedBagType && selectedBagOptionVariantId) {
//             nextBtn.removeAttribute('disabled');
//         } else {
//             nextBtn.setAttribute('disabled', 'disabled');
//         }

//         bagTypeOptions.forEach(option => {
//             const oldClickListenerRef = option.getAttribute('data-listener-ref');
//             if (oldClickListenerRef && window[oldClickListenerRef]) {
//                 option.removeEventListener('click', window[oldClickListenerRef]);
//                 delete window[oldClickListenerRef];
//             }

//             const newClickListenerName = `optionClickHandler${Date.now()}_${(option.dataset.variantTitle || '').replace(/\s+/g, '')}`;
//             window[newClickListenerName] = function() {
//                 bagTypeOptions.forEach(opt => {
//                     opt.classList.remove('active');
//                     const radioInput = opt.querySelector('input[type="radio"]');
//                     if (radioInput) radioInput.checked = false;
//                 });

//                 option.classList.add('active');
//                 const radioInput = option.querySelector('input[type="radio"]');
//                 if (radioInput) radioInput.checked = true;

//                 const variantTitle = option.dataset.variantTitle;
//                 const variantId = option.dataset.variantId;

//                 if (variantTitle && variantTitle.trim() !== '' && variantId) {
//                     saveSelection('bagType', variantTitle);
//                     saveSelection('selectedBagOptionVariantId', variantId);
//                     nextBtn.removeAttribute('disabled');
//                     console.log(`RejoesBuilder: Bag Type selected and saved: ${variantTitle}, Variant ID: ${variantId}`);
//                 } else {
//                     console.warn('RejoesBuilder: Bag Type option has invalid data-variant-title or missing data-variant-id:', option);
//                     alert('Error: Selected bag type is invalid or missing variant ID. Please ensure your template has correct attributes and the base product is configured.');
//                     clearPrefixedSelection('bagType');
//                     clearPrefixedSelection('selectedBagOptionVariantId');
//                     nextBtn.setAttribute('disabled', 'disabled');
//                 }
//             };

//             option.addEventListener('click', window[newClickListenerName]);
//             option.setAttribute('data-listener-ref', newClickListenerName);
//         });

//         const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
//         if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
//             nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
//             delete window[oldNextBtnListenerRef];
//         }

//         const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_4`;
//         window[newNextBtnListenerName] = function() {
//             if (getSelection('bagType') && getSelection('selectedBagOptionVariantId')) {
//                 showStep(5);
//             } else {
//                 alert('Please select a bag type to continue.');
//             }
//         };

//         nextBtn.addEventListener('click', window[newNextBtnListenerName]);
//         nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
//     }

//     function initStep5(sectionElement) {
//         const addToCartBtn = sectionElement.querySelector('#mf-add-to-cart-btn');
//         const oldAddToCartListenerRef = addToCartBtn.getAttribute('data-listener-ref');

//         if (oldAddToCartListenerRef && window[oldAddToCartListenerRef]) {
//             addToCartBtn.removeEventListener('click', window[oldAddToCartListenerRef]);
//             delete window[oldAddToCartListenerRef];
//         }

//         const newAddToCartListenerName = `addToCartHandler${Date.now()}`;
//         window[newAddToCartListenerName] = async (e) => {
//             e.preventDefault();
//             addToCartBtn.textContent = 'Adding...';
//             addToCartBtn.setAttribute('disabled', 'disabled');

//             const selectedVariantId = getSelection('selectedBagOptionVariantId'); 

//             if (!selectedVariantId) {
//                 alert('Cannot add to cart: Selected bag type variant ID is missing. Please go back to step 4 and re-select.');
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//                 return;
//             }

//             const properties = {
//                 "Fit Type": getSelection('fitType'),
//                 "Top Size": getSelection('top_size'),
//                 "Jeans Waist": getSelection('jeans_waist'),
//                 "Jeans Length": getSelection('jeans_length'),
//                 "Sport Bottoms": getSelection('sport_bottoms'),
//                 "Shoe Size": getSelection('shoes_size'),
//                 "Bag Type": getSelection('bagType'),
//             };

//             const success = await handleAddToCart(selectedVariantId, properties, addToCartBtn); 

//             if (!success) {
//                 addToCartBtn.textContent = 'CONTINUE';
//                 addToCartBtn.removeAttribute('disabled');
//             }
//         };

//         addToCartBtn.addEventListener('click', window[newAddToCartListenerName]);
//         addToCartBtn.setAttribute('data-listener-ref', newAddToCartListenerName);
//     }

//     async function initBuilder() { // initBuilder is now async
//         const allStepSections = document.querySelectorAll('.mf-builder-step-section');

//         if (allStepSections.length === 0) {
//             console.warn('RejoesBuilder: No .mf-builder-step-section found. Ensure your sections have this class.');
//             return;
//         }

//         checkAndClearSelectionsIfNeeded();
        
//         document.querySelectorAll('.mf-builder-step-section').forEach(section => {
//             section.style.display = 'none';
//         });

//         // Get the Step 4 section to extract the product handle
//         const step4Section = document.querySelector('.mf-builder-step-section[data-step="4"]');
//         if (step4Section) {
//             await loadBuilderProductData(step4Section); // Await dynamic data loading
//         } else {
//             console.warn("RejoesBuilder: Step 4 section not found during initBuilder. Cannot dynamically load product data. Using fallback data.");
//             await loadBuilderProductData(null); // Fallback to hardcoded if section not found
//         }
        
//         showStep(1); // Show step after product data is loaded
        
//         if (window.location.hash) {
//             window.history.replaceState(null, null, ' ');
//         }
//     }

//     return {
//         init: initBuilder,
//         showStep: showStep,
//         saveSelection: saveSelection,
//         getSelection: getSelection,
//         clearAllSelections: clearAllSelections
//     };
// })();

// document.addEventListener('DOMContentLoaded', () => {
//     RejoesBuilder.init();
// });


const formatPriceForDisplay = (priceInCents) => {
    if (typeof priceInCents !== 'number' || isNaN(priceInCents)) {
        console.error("formatPriceForDisplay: Invalid number provided:", priceInCents);
        return "€N/A";
    }

    const value = priceInCents / 100; // Convert cents to main currency unit (e.g., 5999 -> 59.99)
    
    // Format to two decimal places with comma as decimal separator
    // and add thousand separators (dots) for the integer part
    const parts = value.toFixed(2).toString().split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const decimalPart = parts[1];
    
    return `€${integerPart},${decimalPart}`; // e.g., €5.999,00
};

const RejoesBuilder = (() => {
    const STORAGE_KEY_PREFIX = 'rejoes_mf_';
    let _selectedInspoFile = null;

    let _builderProductData = {
        variants: [] // Dynamically populated from Shopify
    }; 

    async function loadBuilderProductData(sectionElement) {
        const productHandle = sectionElement.dataset.productHandle;
        if (!productHandle) {
            console.error("RejoesBuilder: No product handle found for builder product. Please configure 'Builder Base Product' in section settings for Step 4.");
            // Fallback: If no product handle is set, use hardcoded prices/IDs
            _builderProductData.variants = [
                { title: "The Classic", id: 51583101337943, price: 2999, formatted_price: "€29,99" }, 
                { title: "The Plus", id: 51583101337944, price: 3799, formatted_price: "€37,99" },
                { title: "The Full Drip", id: 51583101337945, price: 5999, formatted_price: "€59,99" }
            ];
            return;
        }

        try {
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const product = await response.json();

            _builderProductData.variants = product.variants.map(variant => {
                let formattedPrice;
                // Use our custom formatter for consistency with the user's specific request
                formattedPrice = formatPriceForDisplay(variant.price);
                
                // If Shopify.formatMoney is available, we still log a warning
                // but prioritize our custom formatting for the exact visual output requested.
                if (typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') {
                    console.warn("Shopify.formatMoney not found. Using custom manual price formatting.");
                }

                return {
                    title: variant.title,
                    id: variant.id,
                    price: variant.price, // Keep price in cents as received from Shopify
                    formatted_price: formattedPrice // This will now be correctly formatted
                };
            });
            console.log("RejoesBuilder: Dynamically loaded builder product data:", _builderProductData);

        } catch (error) {
            console.error("RejoesBuilder: Failed to load builder product data:", error);
            // Fallback: If fetching fails, use hardcoded prices/IDs
            _builderProductData.variants = [
                { title: "The Classic", id: 51583101337943, price: 2999, formatted_price: "€29,99" }, 
                { title: "The Plus", id: 51583101337944, price: 3799, formatted_price: "€37,99" },
                { title: "The Full Drip", id: 51583101337945, price: 5999, formatted_price: "€59,99" }
            ];
        }
    }

    function checkAndClearSelectionsIfNeeded() {
        const hasJustCompleted = sessionStorage.getItem(STORAGE_KEY_PREFIX + 'just_completed');
        
        if (hasJustCompleted || !window.location.href.includes('#')) {
            clearAllSelections();
            sessionStorage.removeItem(STORAGE_KEY_PREFIX + 'just_completed');
            return true;
        }
        return false;
    }

    function saveSelection(key, value) {
        sessionStorage.setItem(STORAGE_KEY_PREFIX + key, JSON.stringify(value));
    }

    function getSelection(key) {
        const stored = sessionStorage.getItem(STORAGE_KEY_PREFIX + key);
        try {
            return stored ? JSON.parse(stored) : null;
        } catch (e) {
            console.error(`Error parsing sessionStorage key "${STORAGE_KEY_PREFIX + key}":`, e);
            return null;
        }
    }

    function clearPrefixedSelection(key) {
        sessionStorage.removeItem(STORAGE_KEY_PREFIX + key);
    }

    function clearAllSelections() {
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key.startsWith(STORAGE_KEY_PREFIX)) {
                sessionStorage.removeItem(key);
                i--;
            }
        }
        _selectedInspoFile = null;
        console.log("All Rejoes Mystery Fits selections cleared.");
    }

    function showStep(stepNumber) {
        const targetSection = document.querySelector(`.mf-builder-step-section[data-step="${stepNumber}"]`);
        if (targetSection) {
            document.querySelectorAll('.mf-builder-step-section').forEach(section => {
                section.style.display = 'none';
            });
            
            targetSection.style.display = 'block';
            
            initStepLogic(stepNumber, targetSection);
            window.history.pushState(null, '', `#step-${stepNumber}`);
            console.log(`RejoesBuilder: Showing step ${stepNumber}.`);

            setTimeout(() => {
                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);

            if (stepNumber === 5) {
                populateOrderSummary();
            }
        } else {
            console.error(`RejoesBuilder: Step ${stepNumber} section not found. Falling back to Step 1.`);
            window.history.pushState(null, '', `#step-1`);
            showStep(1);
        }
    }

    window.addEventListener('popstate', () => {
        const hash = window.location.hash;
        const stepNumber = hash ? parseInt(hash.replace('#step-', '')) : 1;
        showStep(stepNumber);
    });

    async function handleAddToCart(variantId, properties, addToCartBtn) {
        addToCartBtn.textContent = 'Adding...';
        addToCartBtn.setAttribute('disabled', 'disabled');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        for (const key in properties) {
            if (properties.hasOwnProperty(key) && properties[key] !== null && properties[key] !== 'null' && properties[key] !== '') {
                if (key !== "Inspo Image URL") {
                    formData.append(`properties[${key}]`, properties[key]);
                }
            }
        }

        if (_selectedInspoFile) {
            formData.append('properties[Inspo Image]', _selectedInspoFile, _selectedInspoFile.name);
        } else {
            formData.append('properties[Inspo Image]', 'No image uploaded');
        }

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.status) {
                console.error('Add to cart error:', data.description);
                alert('Error adding item to cart: ' + data.description);
                addToCartBtn.textContent = 'CONTINUE';
                addToCartBtn.removeAttribute('disabled');
                return false;
            } else {
                console.log('Item added to cart:', data);
                sessionStorage.setItem(STORAGE_KEY_PREFIX + 'just_completed', 'true');
                clearAllSelections();
                window.location.href = '/cart';
                return true;
            }
        } catch (error) {
            console.error('Network or unexpected error:', error);
            alert('Could not add item to cart. Please try again.');
            addToCartBtn.textContent = 'CONTINUE';
            addToCartBtn.removeAttribute('disabled');
            return false;
        }
    }

    function populateOrderSummary() {
        const summarySection = document.querySelector('.mf-builder-step-section[data-step="5"]');
        if (!summarySection) return;

        const fitType = getSelection('fitType') || 'N/A';

        const topSize = getSelection('top_size') || 'N/A';
        const jeansWaist = getSelection('jeans_waist') || 'N/A';
        const jeansLength = getSelection('jeans_length') || 'N/A';
        const sportBottoms = getSelection('sport_bottoms') || 'N/A';
        const shoesSize = getSelection('shoes_size') || 'N/A';

        const bagType = getSelection('bagType') || 'N/A';
        const inspoFileNameStored = getSelection('inspoFileName'); 

        const selectedSizes = [];
        if (topSize !== 'N/A') selectedSizes.push(`Top: ${topSize}`);
        if (jeansWaist !== 'N/A' || jeansLength !== 'N/A') selectedSizes.push(`Jeans: ${jeansWaist}/${jeansLength}`);
        if (sportBottoms !== 'N/A') selectedSizes.push(`Sport Bottoms: ${sportBottoms}`);
        if (shoesSize !== 'N/A') selectedSizes.push(`Shoes: EU ${shoesSize}`);

        const fitSizeDisplay = selectedSizes.length > 0 ? selectedSizes.join(', ') : 'N/A';

        const fitTypeElement = summarySection.querySelector('[data-summary-field="fit-type"]');
        if (fitTypeElement) fitTypeElement.textContent = fitType;

        const fitSizeElement = summarySection.querySelector('[data-summary-field="fit-size"]');
        if (fitSizeElement) fitSizeElement.textContent = fitSizeDisplay;

        const bagTypeElement = summarySection.querySelector('[data-summary-field="bag-type"]');
        if (bagTypeElement) bagTypeElement.textContent = bagType;

        const inspoImageElement = summarySection.querySelector('[data-summary-field="inspo-image"]');
        if (inspoImageElement) {
            if (_selectedInspoFile || (inspoFileNameStored && inspoFileNameStored !== 'None')) {
                inspoImageElement.textContent = '✅'; 
            } else {
                inspoImageElement.textContent = '❌'; 
            }
        }

        console.log('RejoesBuilder: Order summary populated with:', {
            fitType,
            fitSize: fitSizeDisplay,
            bagType,
            inspoFileName: (_selectedInspoFile || (inspoFileNameStored && inspoFileNameStored !== 'None')) ? '✅' : '❌'
        });
    }

    function initStepLogic(stepNumber, sectionElement) {
        const goBackButton = sectionElement.querySelector('#mf-go-back-btn');
        if (goBackButton) {
            const oldListenerRef = goBackButton.getAttribute('data-listener-ref');
            if (oldListenerRef && window[oldListenerRef]) {
                goBackButton.removeEventListener('click', window[oldListenerRef]);
                delete window[oldListenerRef];
            }

            const newGoBackHandlerName = `goBackHandler${Date.now()}_${stepNumber}`;
            window[newGoBackHandlerName] = () => {
                if (stepNumber > 1) {
                    showStep(stepNumber - 1);
                } else {
                    console.log("RejoesBuilder: Already on Step 1, cannot go back further.");
                }
            };

            goBackButton.addEventListener('click', window[newGoBackHandlerName]);
            goBackButton.setAttribute('data-listener-ref', newGoBackHandlerName);
        }

        switch (stepNumber) {
            case 1: initStep1(sectionElement); break;
            case 2: initStep2(sectionElement); break;
            case 3: initStep3(sectionElement); break;
            case 4: initStep4(sectionElement); break;
            case 5: initStep5(sectionElement); break;
            default: console.warn(`RejoesBuilder: No specific initializer for step ${stepNumber}`);
        }
    }

    function initStep1(sectionElement) {
        const radioGroup = sectionElement.querySelector('.radio-group');
        const choiceLabels = radioGroup ? radioGroup.querySelectorAll('input[type="radio"] + label') : [];
        const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
        let selectedFitType = getSelection('fitType');

        if (selectedFitType) {
            choiceLabels.forEach(label => {
                if (label.dataset.value === selectedFitType) {
                    label.previousElementSibling.checked = true;
                    label.classList.add('active');
                } else {
                    label.classList.remove('active');
                }
            });
            nextBtn.removeAttribute('disabled');
        } else {
            nextBtn.setAttribute('disabled', 'disabled');
        }

        choiceLabels.forEach(label => {
            const oldLabelClickListenerRef = label.getAttribute('data-listener-ref');
            if (oldLabelClickListenerRef && window[oldLabelClickListenerRef]) {
                label.removeEventListener('click', window[oldLabelClickListenerRef]);
                delete window[oldLabelClickListenerRef];
            }

            const newLabelClickHandlerName = `labelClickHandler${Date.now()}_${label.dataset.value.replace(/\s+/g, '')}`;
            window[newLabelClickHandlerName] = function() {
                choiceLabels.forEach(l => l.classList.remove('active'));
                label.classList.add('active');
                saveSelection('fitType', label.dataset.value);
                nextBtn.removeAttribute('disabled');
            };

            label.addEventListener('click', window[newLabelClickHandlerName]);
            label.setAttribute('data-listener-ref', newLabelClickHandlerName);
        });

        const oldNextBtnClickListenerRef = nextBtn.getAttribute('data-listener-ref');
        if (oldNextBtnClickListenerRef && window[oldNextBtnClickListenerRef]) {
            nextBtn.removeEventListener('click', window[oldNextBtnClickListenerRef]);
            delete window[oldNextBtnClickListenerRef];
        }

        const newNextBtnClickHandlerName = `nextBtnClickHandler${Date.now()}_1`;
        window[newNextBtnClickHandlerName] = () => {
            if (getSelection('fitType')) {
                showStep(2);
            } else {
                alert('Please select a gender fit to proceed.');
            }
        };

        nextBtn.addEventListener('click', window[newNextBtnClickHandlerName]);
        nextBtn.setAttribute('data-listener-ref', newNextBtnClickHandlerName);
    }

    function initStep2(sectionElement) {
        const fileInput = sectionElement.querySelector('#mf-step2-inspo-upload');
        const dropzoneContainer = sectionElement.querySelector(".mf-step2-dropzone-container");
        const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

        const uploadPrompt = sectionElement.querySelector('#mf-step2-upload-prompt');
        const uploadPreview = sectionElement.querySelector('#mf-step2-upload-preview');
        const previewImage = sectionElement.querySelector('#mf-step2-preview-image');
        const previewFilename = sectionElement.querySelector('#mf-step2-preview-filename');
        const previewStatus = sectionElement.querySelector('#mf-step2-preview-status');
        const removeFileBtn = sectionElement.querySelector('#mf-step2-remove-file-btn');

        function updateFileState(file) {
            _selectedInspoFile = file;

            if (file) {
                const localPreviewUrl = URL.createObjectURL(file);
                uploadPrompt.classList.add('hidden');
                uploadPreview.classList.remove('hidden');
                previewImage.src = localPreviewUrl;
                previewFilename.textContent = '✅'; 
                previewStatus.textContent = 'File selected';
                nextBtn.removeAttribute('disabled');

                saveSelection('inspoFileName', file.name);
                saveSelection('inspoImageUrl', localPreviewUrl);
            } else {
                uploadPrompt.classList.remove('hidden');
                uploadPreview.classList.add('hidden');
                previewImage.src = '';
                previewFilename.textContent = '❌';
                previewStatus.textContent = 'No file selected';
                nextBtn.setAttribute('disabled', 'disabled');
                
                clearPrefixedSelection('inspoFileName');
                clearPrefixedSelection('inspoImageUrl');
                if (fileInput) fileInput.value = '';
            }
        }

        if (_selectedInspoFile) {
            updateFileState(_selectedInspoFile);
        } else if (getSelection('inspoFileName')) {
            uploadPrompt.classList.add('hidden');
            uploadPreview.classList.remove('hidden');
            previewImage.src = getSelection('inspoImageUrl') || 'https://via.placeholder.com/150?text=No+Preview';
            previewFilename.textContent = '✅'; // Updated to show '✅' for previously selected file too
            previewStatus.textContent = 'File previously selected (re-upload to include in order)';
            nextBtn.setAttribute('disabled', 'disabled');
        } else {
            updateFileState(null);
        }

        const oldFileInputListenerRef = fileInput.getAttribute('data-listener-ref');
        if (oldFileInputListenerRef && window[oldFileInputListenerRef]) {
            fileInput.removeEventListener('change', window[oldFileInputListenerRef]);
            delete window[oldFileInputListenerRef];
        }

        const oldDropoverListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragover');
        if (oldDropoverListenerRef && window[oldDropoverListenerRef]) {
            dropzoneContainer.removeEventListener('dragover', window[oldDropoverListenerRef]);
            delete window[oldDropoverListenerRef];
        }

        const oldDragleaveListenerRef = dropzoneContainer.getAttribute('data-listener-ref-dragleave');
        if (oldDragleaveListenerRef && window[oldDragleaveListenerRef]) {
            dropzoneContainer.removeEventListener('dragleave', window[oldDragleaveListenerRef]);
            delete window[oldDragleaveListenerRef];
        }

        const oldDropListenerRef = dropzoneContainer.getAttribute('data-listener-ref-drop');
        if (oldDropListenerRef && window[oldDropListenerRef]) {
            dropzoneContainer.removeEventListener('drop', window[oldDropListenerRef]);
            delete window[oldDropListenerRef];
        }

        const oldRemoveFileListenerRef = removeFileBtn.getAttribute('data-listener-ref');
        if (oldRemoveFileListenerRef && window[oldRemoveFileListenerRef]) {
            removeFileBtn.removeEventListener('click', window[oldRemoveFileListenerRef]);
            delete window[oldRemoveFileListenerRef];
        }

        const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
        if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
            nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
            delete window[oldNextBtnListenerRef];
        }

        const handleFileRemove = () => {
            fileInput.value = '';
            updateFileState(null);
        };

        const newFileInputListenerName = `fileInputHandler${Date.now()}`;
        window[newFileInputListenerName] = function(event) {
            const file = event.target.files[0];
            if (!file) {
                handleFileRemove();
                return;
            }

        const maxSize = 10 * 1024 * 1024; 
            if (file.size > maxSize) {
                alert('File is too large. Maximum size is 10MB.'); 
                handleFileRemove();
                return;
            }

            updateFileState(file);
            console.log("RejoesBuilder: File selected for Uploadery:", file.name);
        };

        fileInput.addEventListener("change", window[newFileInputListenerName]);
        fileInput.setAttribute('data-listener-ref', newFileInputListenerName);

        const newDragoverListenerName = `dragoverHandler${Date.now()}`;
        window[newDragoverListenerName] = function(event) {
            event.preventDefault();
            dropzoneContainer.classList.add("drag-over");
        };

        dropzoneContainer.addEventListener("dragover", window[newDragoverListenerName]);
        dropzoneContainer.setAttribute('data-listener-ref-dragover', newDragoverListenerName);

        const newDragleaveListenerName = `dragleaveHandler${Date.now()}`;
        window[newDragleaveListenerName] = function(event) {
            dropzoneContainer.classList.remove("drag-over");
        };

        dropzoneContainer.addEventListener("dragleave", window[newDragleaveListenerName]);
        dropzoneContainer.setAttribute('data-listener-ref-dragleave', newDragleaveListenerName);

        const newDropListenerName = `dropHandler${Date.now()}`;
        window[newDropListenerName] = function(event) {
            event.preventDefault();
            dropzoneContainer.classList.remove("drag-over");
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(files[0]);
                fileInput.files = dataTransfer.files;
                fileInput.dispatchEvent(new Event('change'));
            }
        };

        dropzoneContainer.addEventListener("drop", window[newDropListenerName]);
        dropzoneContainer.setAttribute('data-listener-ref-drop', newDropListenerName);

        const newRemoveFileListenerName = `removeFileHandler${Date.now()}`;
        window[newRemoveFileListenerName] = handleFileRemove;

        removeFileBtn.addEventListener('click', window[newRemoveFileListenerName]);
        removeFileBtn.setAttribute('data-listener-ref', newRemoveFileListenerName);

        const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_2`;
        window[newNextBtnListenerName] = function() {
            if (_selectedInspoFile) {
                showStep(3);
            } else {
                alert('Please upload an inspiration image to proceed.');
            }
        };

        nextBtn.addEventListener('click', window[newNextBtnListenerName]);
        nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
    }

    function initStep3(sectionElement) {
        const sizeSelectors = sectionElement.querySelectorAll(".mf-step3-size-selector select");
        const nextBtn = sectionElement.querySelector('#mf-next-step-btn');

        sizeSelectors.forEach(selectElement => {
            const optionName = selectElement.name;
            let savedValue = getSelection(optionName);

            if (savedValue) {
                selectElement.value = savedValue;
            }

            const oldChangeListenerRef = selectElement.getAttribute('data-listener-ref');
            if (oldChangeListenerRef && window[oldChangeListenerRef]) {
                selectElement.removeEventListener('change', window[oldChangeListenerRef]);
                delete window[oldChangeListenerRef];
            }

            const newChangeListenerName = `selectChangeListener${Date.now()}_${optionName}`;
            window[newChangeListenerName] = function() {
                saveSelection(optionName, this.value);
                console.log(`RejoesBuilder: Saved ${optionName}:`, this.value);
                updateNextButtonState();
            };

            selectElement.addEventListener("change", window[newChangeListenerName]);
            selectElement.setAttribute('data-listener-ref', newChangeListenerName);
        });

        function updateNextButtonState() {
            const allSelected = Array.from(sizeSelectors).every(select => select.value !== '');
            
            if (allSelected) {
                nextBtn.removeAttribute('disabled');
            } else {
                nextBtn.setAttribute('disabled', 'disabled');
            }
        }

        updateNextButtonState();

        const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
        if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
            nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
            delete window[oldNextBtnListenerRef];
        }

        const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_3`;
        window[newNextBtnListenerName] = function() {
            if (Array.from(sizeSelectors).every(select => select.value !== '')) {
                console.log("RejoesBuilder: Next button clicked in Step 3. Proceeding to Step 4.");
                showStep(4);
            } else {
                alert('Please select all sizes to proceed.');
                console.warn("RejoesBuilder: Attempted to proceed from Step 3 without selecting all sizes.");
            }
        };

        nextBtn.addEventListener('click', window[newNextBtnListenerName]);
        nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
    }

    function initStep4(sectionElement) {
        const bagTypeOptions = sectionElement.querySelectorAll('.mf-step4-bag-type-option');
        const nextBtn = sectionElement.querySelector('#mf-next-step-btn');
        let selectedBagType = getSelection('bagType');
        let selectedBagOptionVariantId = getSelection('selectedBagOptionVariantId');

        const variantsMap = {};
        if (_builderProductData.variants) {
            _builderProductData.variants.forEach(variant => {
                variantsMap[variant.title] = variant;
            });
        }

        bagTypeOptions.forEach(option => {
            const variantTitle = option.dataset.variantTitle;
            const priceSpan = option.querySelector('.mf-bag-type-price');
            const variant = variantsMap[variantTitle];

            if (priceSpan && variant) {
                // Use the formatted_price which should already be correctly formatted
                priceSpan.textContent = variant.formatted_price;
                option.dataset.variantId = variant.id;
            } else if (priceSpan) {
                priceSpan.textContent = 'Error: Price N/A'; // Show error if variant data is missing
            }

            if (variantTitle === selectedBagType) {
                option.classList.add('active');
                const radioInput = option.querySelector('input[type="radio"]');
                if (radioInput) radioInput.checked = true;
            } else {
                option.classList.remove('active');
                const radioInput = option.querySelector('input[type="radio"]');
                if (radioInput) radioInput.checked = false;
            }
        });

        if (selectedBagType && selectedBagOptionVariantId) {
            nextBtn.removeAttribute('disabled');
        } else {
            nextBtn.setAttribute('disabled', 'disabled');
        }

        bagTypeOptions.forEach(option => {
            const oldClickListenerRef = option.getAttribute('data-listener-ref');
            if (oldClickListenerRef && window[oldClickListenerRef]) {
                option.removeEventListener('click', window[oldClickListenerRef]);
                delete window[oldClickListenerRef];
            }

            const newClickListenerName = `optionClickHandler${Date.now()}_${(option.dataset.variantTitle || '').replace(/\s+/g, '')}`;
            window[newClickListenerName] = function() {
                bagTypeOptions.forEach(opt => {
                    opt.classList.remove('active');
                    const radioInput = opt.querySelector('input[type="radio"]');
                    if (radioInput) radioInput.checked = false;
                });

                option.classList.add('active');
                const radioInput = option.querySelector('input[type="radio"]');
                if (radioInput) radioInput.checked = true;

                const variantTitle = option.dataset.variantTitle;
                const variantId = option.dataset.variantId;

                if (variantTitle && variantTitle.trim() !== '' && variantId) {
                    saveSelection('bagType', variantTitle);
                    saveSelection('selectedBagOptionVariantId', variantId);
                    nextBtn.removeAttribute('disabled');
                    console.log(`RejoesBuilder: Bag Type selected and saved: ${variantTitle}, Variant ID: ${variantId}`);
                } else {
                    console.warn('RejoesBuilder: Bag Type option has invalid data-variant-title or missing data-variant-id:', option);
                    alert('Error: Selected bag type is invalid or missing variant ID. Please ensure your template has correct attributes and the base product is configured.');
                    clearPrefixedSelection('bagType');
                    clearPrefixedSelection('selectedBagOptionVariantId');
                    nextBtn.setAttribute('disabled', 'disabled');
                }
            };

            option.addEventListener('click', window[newClickListenerName]);
            option.setAttribute('data-listener-ref', newClickListenerName);
        });

        const oldNextBtnListenerRef = nextBtn.getAttribute('data-listener-ref');
        if (oldNextBtnListenerRef && window[oldNextBtnListenerRef]) {
            nextBtn.removeEventListener('click', window[oldNextBtnListenerRef]);
            delete window[oldNextBtnListenerRef];
        }

        const newNextBtnListenerName = `nextBtnClickHandler${Date.now()}_4`;
        window[newNextBtnListenerName] = function() {
            if (getSelection('bagType') && getSelection('selectedBagOptionVariantId')) {
                showStep(5);
            } else {
                alert('Please select a bag type to continue.');
            }
        };

        nextBtn.addEventListener('click', window[newNextBtnListenerName]);
        nextBtn.setAttribute('data-listener-ref', newNextBtnListenerName);
    }

    function initStep5(sectionElement) {
        const addToCartBtn = sectionElement.querySelector('#mf-add-to-cart-btn');
        const oldAddToCartListenerRef = addToCartBtn.getAttribute('data-listener-ref');

        if (oldAddToCartListenerRef && window[oldAddToCartListenerRef]) {
            addToCartBtn.removeEventListener('click', window[oldAddToCartListenerRef]);
            delete window[oldAddToCartListenerRef];
        }

        const newAddToCartListenerName = `addToCartHandler${Date.now()}`;
        window[newAddToCartListenerName] = async (e) => {
            e.preventDefault();
            addToCartBtn.textContent = 'Adding...';
            addToCartBtn.setAttribute('disabled', 'disabled');

            const selectedVariantId = getSelection('selectedBagOptionVariantId'); 

            if (!selectedVariantId) {
                alert('Cannot add to cart: Selected bag type variant ID is missing. Please go back to step 4 and re-select.');
                addToCartBtn.textContent = 'CONTINUE';
                addToCartBtn.removeAttribute('disabled');
                return;
            }

            const properties = {
                "Fit Type": getSelection('fitType'),
                "Top Size": getSelection('top_size'),
                "Jeans Waist": getSelection('jeans_waist'),
                "Jeans Length": getSelection('jeans_length'),
                "Sport Bottoms": getSelection('sport_bottoms'),
                "Shoe Size": getSelection('shoes_size'),
                "Bag Type": getSelection('bagType'),
            };

            const success = await handleAddToCart(selectedVariantId, properties, addToCartBtn); 

            if (!success) {
                addToCartBtn.textContent = 'CONTINUE';
                addToCartBtn.removeAttribute('disabled');
            }
        };

        addToCartBtn.addEventListener('click', window[newAddToCartListenerName]);
        addToCartBtn.setAttribute('data-listener-ref', newAddToCartListenerName);
    }

    async function initBuilder() { // initBuilder is now async
        const allStepSections = document.querySelectorAll('.mf-builder-step-section');

        if (allStepSections.length === 0) {
            console.warn('RejoesBuilder: No .mf-builder-step-section found. Ensure your sections have this class.');
            return;
        }

        checkAndClearSelectionsIfNeeded();
        
        document.querySelectorAll('.mf-builder-step-section').forEach(section => {
            section.style.display = 'none';
        });

        // Get the Step 4 section to extract the product handle
        const step4Section = document.querySelector('.mf-builder-step-section[data-step="4"]');
        if (step4Section) {
            await loadBuilderProductData(step4Section); // Await dynamic data loading
        } else {
            console.warn("RejoesBuilder: Step 4 section not found during initBuilder. Cannot dynamically load product data. Using fallback data.");
            await loadBuilderProductData(null); // Fallback to hardcoded if section not found
        }
        
        showStep(1); // Show step after product data is loaded
        
        if (window.location.hash) {
            window.history.replaceState(null, null, ' ');
        }
    }

    return {
        init: initBuilder,
        showStep: showStep,
        saveSelection: saveSelection,
        getSelection: getSelection,
        clearAllSelections: clearAllSelections
    };
})();

document.addEventListener('DOMContentLoaded', () => {
    RejoesBuilder.init();
});